import React from 'react';
import Tokens from '@zapier/design-tokens';

const Colors = {
  GrayWarm1: Tokens.GrayWarm1,
  GrayWarm2: Tokens.GrayWarm2,
  GrayWarm3: Tokens.GrayWarm3,
  GrayWarm4: Tokens.GrayWarm4,
  GrayWarm5: Tokens.GrayWarm5,
  GrayWarm6: Tokens.GrayWarm6,
  GrayWarm7: Tokens.GrayWarm7,
  GrayWarm8: Tokens.GrayWarm8,
  GrayWarm9: Tokens.GrayWarm9,
  GrayWarm10: Tokens.GrayWarm10,
  BrandOrange: Tokens.BrandOrange,
  BrandEarth: Tokens.BrandEarth,
  BrandLavender: Tokens.BrandLavender,
  BrandNight: Tokens.BrandNight,
  BrandAlmostWhite: Tokens.BrandAlmostWhite,
  BrandPeach: Tokens.BrandPeach,
  BrandCream: Tokens.BrandCream,
  BrandBolt: Tokens.BrandBolt,
  BrandSky: Tokens.BrandSky,
  BrandMoss: Tokens.BrandMoss,
  Purple1: Tokens.ColorPurple1,
  Purple2: Tokens.ColorPurple2,
  Purple3: Tokens.ColorPurple3,
  Purple4: Tokens.ColorPurple4,
  Purple5: Tokens.ColorPurple5,
  Yellow1: Tokens.ColorYellow1,
  Yellow2: Tokens.ColorYellow2,
  Yellow3: Tokens.ColorYellow3,
  Yellow4: Tokens.ColorYellow4,
  Yellow5: Tokens.ColorYellow5,
  Red1: Tokens.ColorRed1,
  Red2: Tokens.ColorRed2,
  Red3: Tokens.ColorRed3,
  Red4: Tokens.ColorRed4,
  Red5: Tokens.ColorRed5,
  Blue1: Tokens.ColorBlue1,
  Blue2: Tokens.ColorBlue2,
  Blue3: Tokens.ColorBlue3,
  Blue4: Tokens.ColorBlue4,
  Blue5: Tokens.ColorBlue5,
  Orange1: Tokens.ColorOrange1,
  Orange2: Tokens.ColorOrange2,
  Orange3: Tokens.ColorOrange3,
  Orange4: Tokens.ColorOrange4,
  Orange5: Tokens.ColorOrange5,
  Teal1: Tokens.ColorTeal1,
  Teal2: Tokens.ColorTeal2,
  Teal3: Tokens.ColorTeal3,
  Teal4: Tokens.ColorTeal4,
  Teal5: Tokens.ColorTeal5,
  Green1: Tokens.ColorGreen1,
  Green2: Tokens.ColorGreen2,
  Green3: Tokens.ColorGreen3,
  Green4: Tokens.ColorGreen4,
  Green5: Tokens.ColorGreen5,
  Pink1: Tokens.ColorPink1,
  Pink2: Tokens.ColorPink2,
  Pink3: Tokens.ColorPink3,
  Pink4: Tokens.ColorPink4,
  Pink5: Tokens.ColorPink5,
  PrimeWhite: Tokens.PrimeWhite,
  PrimeBlack: Tokens.PrimeBlack,
  PrimePurple: Tokens.PrimePurple,
  PrimeBlue: Tokens.PrimeBlue,
  PrimeTeal: Tokens.PrimeTeal,
  PrimeGreen: Tokens.PrimeGreen,
  PrimeYellow: Tokens.PrimeYellow,
  PrimeOrange: Tokens.PrimeOrange,
  PrimeRed: Tokens.PrimeRed,
  PrimePink: Tokens.PrimePink,
  UiBrandWeakest: Tokens.UiBrandWeakest,
  UiBrandWeaker: Tokens.UiBrandWeaker,
  UiBrand: Tokens.UiBrand,
  UiBrandStronger: Tokens.UiBrandStrongest,
  UiBrandStrongest: Tokens.UiBrandStrongest,
  UiPrimaryWeakest: Tokens.UiPrimaryWeakest,
  UiPrimaryWeaker: Tokens.UiPrimaryWeaker,
  UiPrimary: Tokens.UiPrimary,
  UiPrimaryStronger: Tokens.UiPrimaryStronger,
  UiPrimaryStrongest: Tokens.UiPrimaryStrongest,
  StatusWarningWeakest: Tokens.StatusWarningWeakest,
  StatusWarningWeaker: Tokens.StatusWarningWeaker,
  StatusWarning: Tokens.StatusWarning,
  StatusWarningStronger: Tokens.StatusWarningStronger,
  StatusWarningStrongest: Tokens.StatusWarningStrongest,
  StatusErrorWeakest: Tokens.StatusErrorWeakest,
  StatusErrorWeaker: Tokens.StatusErrorWeaker,
  StatusError: Tokens.StatusError,
  StatusErrorStronger: Tokens.StatusErrorStronger,
  StatusErrorStrongest: Tokens.StatusErrorStrongest,
  StatusSuccessWeakest: Tokens.StatusSuccessWeakest,
  StatusSuccessWeaker: Tokens.StatusSuccessWeaker,
  StatusSuccess: Tokens.StatusSuccess,
  StatusSuccessStronger: Tokens.StatusSuccessStronger,
  StatusSuccessStrongest: Tokens.StatusSuccessStrongest,
  BackgroundWeaker: Tokens.BackgroundWeaker,
  BackgroundDefault: Tokens.BackgroundDefault,
  BackgroundStronger: Tokens.BackgroundStronger,
  BackgroundStrongest: Tokens.BackgroundStrongest,
  BackgroundSelected: Tokens.BackgroundSelected,
  BackgroundOverlay: Tokens.BackgroundOverlay,
  StrokeWeaker: Tokens.StrokeWeaker,
  StrokeDefault: Tokens.StrokeDefault,
  StrokeStronger: Tokens.StrokeStronger,
  StrokeSelected: Tokens.StrokeSelected,
  ReservedBeta: Tokens.ReservedBeta,
  ReservedInvite: Tokens.ReservedInvite,
  ReservedFree: Tokens.ReservedFree,
  TextWeakest: Tokens.TextWeakest,
  TextWeaker: Tokens.TextWeaker,
  TextDefault: Tokens.TextDefault,
  TextStronger: Tokens.TextStronger,
  TextLink: Tokens.TextLink,
  TextLinkHover: Tokens.TextLinkHover,
  TextInverted: Tokens.TextInverted,
  // special colors
  transparent: "transparent",
  inherit: "inherit",
  currentColor: "currentColor"
};

function zapierLogo(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: 2, y: 2, width: 20, height: 20, rx: 3, fill: "currentColor" })
  );
}

function teamFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.79 3H2V21H22V5H12.47L10.79 3ZM10.25 9.5C11.08 9.5 11.75 10.17 11.75 11C11.75 11.83 11.08 12.5 10.25 12.5C9.42 12.5 8.75 11.83 8.75 11C8.75 10.17 9.42 9.5 10.25 9.5ZM15.75 9.5C16.58 9.5 17.25 10.17 17.25 11C17.25 11.83 16.58 12.5 15.75 12.5C14.92 12.5 14.25 11.83 14.25 11C14.25 10.17 14.92 9.5 15.75 9.5ZM17.91 14L18.64 16H14.92L14.19 14H17.91ZM13.32 16H7.36L8.09 14H12.59L13.32 16Z", fill: "currentColor" })
  );
}

function team(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.47 5L10.79 3H2V17H4V5H9.86L11.53 7H20V19H2V21H22V5H12.47Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.25 12.5C11.0784 12.5 11.75 11.8284 11.75 11C11.75 10.1716 11.0784 9.5 10.25 9.5C9.42157 9.5 8.75 10.1716 8.75 11C8.75 11.8284 9.42157 12.5 10.25 12.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.75 12.5C16.5784 12.5 17.25 11.8284 17.25 11C17.25 10.1716 16.5784 9.5 15.75 9.5C14.9216 9.5 14.25 10.1716 14.25 11C14.25 11.8284 14.9216 12.5 15.75 12.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.9102 16H18.6402L17.9102 14H14.1802L14.9102 16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.35986 16H13.3199L12.5899 14H8.08986L7.35986 16Z", fill: "currentColor" })
  );
}

function statusStopFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.075 4.9325C15.165 1.0225 8.835 1.0225 4.925 4.9325C1.025 8.8325 1.025 15.1725 4.925 19.0725C8.835 22.9825 15.165 22.9825 19.075 19.0725C22.985 15.1725 22.985 8.8325 19.075 4.9325ZM16 8H7.99999V16H16V8Z", fill: "currentColor" })
  );
}

function statusStop(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.0701 4.93C15.1601 1.02 8.83012 1.02 4.92012 4.93C1.02012 8.83 1.02012 15.17 4.92012 19.07C8.83012 22.98 15.1601 22.98 19.0701 19.07C22.9801 15.17 22.9801 8.83 19.0701 4.93ZM17.6601 17.66C14.5301 20.78 9.47012 20.79 6.34012 17.66C3.22012 14.54 3.22012 9.47 6.34012 6.35C9.47012 3.23 14.5301 3.22 17.6601 6.35C20.7801 9.46 20.7801 14.54 17.6601 17.66Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 8H16V16H8V8Z", fill: "currentColor" })
  );
}

function statusStatusFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13.8167 13.3576L10.0901 5.95447L7.13151 10.7353H3.73145L3.73225 12.7353H7.68866H8.24581L9.91038 10.0455L13.7345 17.6424L16.4453 12.7353H20.0002V10.7353H15.2653L13.8167 13.3576Z", fill: "currentColor" })
  );
}

function statusStatus(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4.09941 10.7353C4.70567 6.91797 8.01207 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.82962 20 4.40455 16.8089 4.03334 12.7353H7.68809H8.24532L9.90989 10.0455L13.734 17.6424L16.4449 12.7353H18.2575V10.7353H15.2648L13.8162 13.3576L10.0896 5.95448L7.13103 10.7353H4.09941Z", fill: "currentColor" })
  );
}

function statusPlayingFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 20.37L19.5 12L5 3.63V20.37Z", fill: "currentColor" })
  );
}

function statusPlaying(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 20.37L19.5 12L5 3.63V20.37ZM7 7.09L15.5 12L7 16.91V7.09Z", fill: "currentColor" })
  );
}

function statusPaused(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 5H7V19H10V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 5H14V19H17V5Z", fill: "currentColor" })
  );
}

function statusFilterFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.99986 11.51V21.72L14.9999 18.29V11.51L22.1399 3H1.85986L8.99986 11.51Z", fill: "currentColor" })
  );
}

function statusFilter(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.52986 5H17.8599L12.9999 10.79V17.13L10.9999 18.28V10.79L7.81986 7H5.20986L8.99986 11.51V21.72L14.9999 18.29V11.51L22.1399 3H1.85986L3.52986 5Z", fill: "currentColor" })
  );
}

function ratingWinkAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.2799 12.95C16.7399 14.89 14.4599 16 11.9999 16C9.5399 16 7.2599 14.89 5.7199 12.95L4.1499 14.19C6.0699 16.61 8.9299 18 11.9999 18C15.0699 18 17.9299 16.61 19.8399 14.19L18.2799 12.95Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10 7H6V9H10V7Z", fill: "currentColor" })
  );
}

function ratingWink(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.9998 16C10.5698 16 9.27982 15.25 8.54982 13.99L6.81982 14.99C7.89982 16.85 9.87982 18 11.9998 18C14.1198 18 16.0998 16.85 17.1798 14.99L15.4498 13.99C14.7198 15.25 13.4298 16 11.9998 16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.25 8.5H6.75V10.5H10.25V8.5Z", fill: "currentColor" })
  );
}

function ratingVerySadAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 11.75C8.4665 11.75 9.25 10.9665 9.25 10C9.25 9.0335 8.4665 8.25 7.5 8.25C6.5335 8.25 5.75 9.0335 5.75 10C5.75 10.9665 6.5335 11.75 7.5 11.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 11.75C17.4665 11.75 18.25 10.9665 18.25 10C18.25 9.0335 17.4665 8.25 16.5 8.25C15.5335 8.25 14.75 9.0335 14.75 10C14.75 10.9665 15.5335 11.75 16.5 11.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.0002 13C8.93018 13 6.36018 15.13 5.68018 18H18.3202C17.6402 15.13 15.0702 13 12.0002 13Z", fill: "currentColor" })
  );
}

function ratingVerySad(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 12C9.24 12 7 14.24 7 17H17C17 14.24 14.76 12 12 12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" })
  );
}

function ratingVeryHappyAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M5.68018 13C6.36018 15.87 8.93018 18 12.0002 18C15.0702 18 17.6402 15.87 18.3202 13H5.68018Z", fill: "currentColor" })
  );
}

function ratingVeryHappy(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 18C14.76 18 17 15.76 17 13H7C7 15.76 9.24 18 12 18Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" })
  );
}

function ratingThumbsUpFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 20H4V9H2V20ZM19 7H15V4C15 3.46957 14.7893 2.96086 14.4142 2.58579C14.0391 2.21071 13.5304 2 13 2H11.57L6 8.64V20H16.47L22 13.4V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7Z", fill: "currentColor" })
  );
}

function ratingThumbsUp(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19 7H15V4C15 3.46957 14.7893 2.96086 14.4142 2.58579C14.0391 2.21071 13.5304 2 13 2H11.57L6 8.64V16H8V9.36L12.5 4H13V9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V12.68L15.53 18H6V20H16.47L22 13.4V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM2 20H4V9H2V20Z", fill: "currentColor" })
  );
}

function ratingThumbsDownFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 4V15H22V4H20ZM2 10.6V14C2 14.7956 2.31607 15.5587 2.87868 16.1213C3.44129 16.6839 4.20435 17 5 17H9V20C9 20.5304 9.21071 21.0391 9.58579 21.4142C9.96086 21.7893 10.4696 22 11 22H12.43L18 15.36V4H7.53L2 10.6Z", fill: "currentColor" })
  );
}

function ratingThumbsDown(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 10.6V14C2 14.7956 2.31607 15.5587 2.87868 16.1213C3.44129 16.6839 4.20435 17 5 17H9V20C9 20.5304 9.21071 21.0391 9.58578 21.4142C9.96086 21.7893 10.4696 22 11 22H12.43L18 15.36V8H16V14.64L11.5 20H11V15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14V11.32L8.47 6H18V4H7.53L2 10.6ZM20 4V15H22V4H20Z", fill: "currentColor" })
  );
}

function ratingThumbsBothFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 10L11 14.81V17.5C11 18.0304 11.2107 18.5391 11.5858 18.9142C11.9609 19.2893 12.4696 19.5 13 19.5H16V21C16 21.5304 16.2107 22.0391 16.5858 22.4142C16.9609 22.7893 17.4696 23 18 23H19L23 18.24V10H15ZM13 6.5C13 5.96957 12.7893 5.46086 12.4142 5.08579C12.0391 4.71071 11.5304 4.5 11 4.5H8V3C8 2.46957 7.78929 1.96086 7.41421 1.58579C7.03914 1.21071 6.53043 1 6 1H5L1 5.76V14H9L13 9.19V6.5Z", fill: "currentColor" })
  );
}

function ratingThumbsBoth(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 12H23V10H15L11 14.81V17.5C11 18.0304 11.2107 18.5391 11.5858 18.9142C11.9609 19.2893 12.4696 19.5 13 19.5H16V21C16 21.5304 16.2107 22.0391 16.5858 22.4142C16.9609 22.7893 17.4696 23 18 23H19L23 18.24V14H21V17.51L18.0699 21H18V17.5H13V15.5L16 12ZM13 6.5C13 5.96957 12.7893 5.46086 12.4142 5.08578C12.0391 4.71071 11.5304 4.5 11 4.5H8V3C8 2.46957 7.78926 1.96086 7.41418 1.58578C7.03911 1.21071 6.53043 1 6 1H5L1 5.76001V10H3V6.48999L5.93005 3H6V6.5H11V8.5L8 12.03H1V14.03H9L13 9.22V6.5Z", fill: "currentColor" })
  );
}

function ratingStarFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.8398 8.27998L15.7598 7.38998L13.0898 1.97998H10.9098L8.23977 7.38998L2.15977 8.27998L1.50977 10.26L5.90977 14.55L4.83977 20.78L6.39977 21.91L11.9998 18.97L17.5998 21.91L19.1598 20.78L18.0898 14.55L22.4898 10.26L21.8398 8.27998Z", fill: "currentColor" })
  );
}

function ratingStar(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22.4902 10.26L21.8402 8.27998L15.7602 7.38998L13.0902 1.97998H10.9102L8.24021 7.38998L2.16021 8.27998L1.47021 10.4L9.57021 9.21998L12.0002 4.28998L14.4302 9.21998L19.8802 10.01L15.9402 13.85L16.8702 19.27L12.0002 16.71L7.13021 19.27L8.06021 13.85L5.92021 11.77L3.43021 12.13L5.91021 14.55L4.84021 20.78L6.40022 21.91L12.0002 18.97L17.6002 21.91L19.1602 20.78L18.0902 14.55L22.4902 10.26Z", fill: "currentColor" })
  );
}

function ratingSadAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.0002 13C8.93016 13 6.07016 14.39 4.16016 16.81L5.73016 18.05C7.26016 16.11 9.54016 15 12.0002 15C14.4602 15 16.7402 16.11 18.2802 18.05L19.8502 16.81C17.9302 14.39 15.0702 13 12.0002 13Z", fill: "currentColor" })
  );
}

function ratingSad(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.9998 13C9.87982 13 7.89982 14.15 6.81982 16.01L8.54982 17.01C9.27982 15.75 10.5698 15 11.9998 15C13.4298 15 14.7198 15.75 15.4498 17.01L17.1798 16.01C16.0998 14.15 14.1198 13 11.9998 13Z", fill: "currentColor" })
  );
}

function ratingNeutralAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 14H6V16H18V14Z", fill: "currentColor" })
  );
}

function ratingNeutral(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 14H8V16H16V14Z", fill: "currentColor" })
  );
}

function ratingHeartFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 21.31C13.03 20.45 16.11 17.96 21.01 12.58C22.06 11.43 22.58 9.94005 22.49 8.39005C22.4 6.84005 21.71 5.43005 20.54 4.41005C18.51 2.64005 15.54 2.57005 13.42 4.08005C14.46 5.29005 14.93 5.85005 16.11 7.32005L14.55 8.58005C13.75 7.59005 11.56 5.00005 11.46 4.88005C9.36999 2.58005 5.76999 2.37005 3.42999 4.41005C1.04999 6.49005 0.829988 10.06 2.93999 12.55C6.36999 16.59 9.67999 19.34 12 21.31Z", fill: "currentColor" })
  );
}

function ratingHeart(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 21.31C13.02 20.45 16.11 17.96 21.01 12.58C22.06 11.43 22.58 9.94 22.49 8.39C22.4 6.85 21.71 5.43 20.54 4.42C18.51 2.65 15.54 2.58 13.42 4.09C13.94 4.7 14.33 5.15 14.73 5.63C16.1 4.74 17.95 4.81 19.23 5.93C19.99 6.59 20.44 7.51 20.5 8.51C20.56 9.52 20.21 10.49 19.53 11.24C16.84 14.19 14.31 16.7 12 18.7C10.01 16.99 7.25999 14.56 4.46999 11.27C3.06999 9.61 3.19999 7.27 4.73999 5.92C6.25999 4.59 8.60999 4.73 9.97999 6.23C10.37 6.66 12.59 9.29 13.02 9.8L14.53 8.55C13.63 7.43 11.56 4.99 11.46 4.89C9.36999 2.59 5.76999 2.38 3.42999 4.42C1.04999 6.5 0.829988 10.07 2.93999 12.56C6.36999 16.59 9.69999 19.35 12 21.31Z", fill: "currentColor" })
  );
}

function ratingHappyAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.2799 12.95C16.7399 14.89 14.4599 16 11.9999 16C9.5399 16 7.2599 14.89 5.7199 12.95L4.1499 14.19C6.0699 16.61 8.9299 18 11.9999 18C15.0699 18 17.9299 16.61 19.8399 14.19L18.2799 12.95Z", fill: "currentColor" })
  );
}

function ratingHappy(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.5 11.25C9.4665 11.25 10.25 10.4665 10.25 9.5C10.25 8.5335 9.4665 7.75 8.5 7.75C7.5335 7.75 6.75 8.5335 6.75 9.5C6.75 10.4665 7.5335 11.25 8.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.9998 16C10.5698 16 9.27982 15.25 8.54982 13.99L6.81982 14.99C7.89982 16.85 9.87982 18 11.9998 18C14.1198 18 16.0998 16.85 17.1798 14.99L15.4498 13.99C14.7198 15.25 13.4298 16 11.9998 16Z", fill: "currentColor" })
  );
}

function ratingCool(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 4C14.74 4 17.17 5.39 18.61 7.5H15C14.28 7.5 13.68 7.88 13.33 8.43C12.48 8.12 11.53 8.12 10.68 8.43C10.32 7.88 9.72 7.5 9 7.5H5.39C6.83 5.39 9.26 4 12 4ZM12 20C7.59 20 4 16.41 4 12C4 11.03 4.18 10.1 4.5 9.24V9.79C4.5 10.26 4.61 10.72 4.82 11.13L5.2 11.89C5.54 12.57 6.23 13 6.99 13H8.7C9.65 13 10.47 12.33 10.66 11.39L10.95 9.93C11.6 9.6 12.39 9.6 13.04 9.93L13.33 11.39C13.53 12.33 14.35 13 15.3 13H17.01C17.77 13 18.46 12.57 18.8 11.89L19.18 11.13C19.39 10.71 19.5 10.25 19.5 9.79V9.24C19.82 10.1 20 11.03 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.9998 16C10.5698 16 9.27982 15.25 8.54982 13.99L6.81982 14.99C7.89982 16.85 9.87982 18 11.9998 18C14.1198 18 16.0998 16.85 17.1798 14.99L15.4498 13.99C14.7198 15.25 13.4298 16 11.9998 16Z", fill: "currentColor" })
  );
}

function personSettings(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.26246 9.75C8.26246 10.4917 8.48239 11.2167 8.89445 11.8334C9.30651 12.4501 9.89218 12.9307 10.5774 13.2146C11.2626 13.4984 12.0166 13.5726 12.7441 13.4279C13.4715 13.2833 14.1397 12.9261 14.6641 12.4017C15.1886 11.8772 15.5457 11.209 15.6904 10.4816C15.8351 9.75415 15.7608 9.00016 15.477 8.31494C15.1932 7.62972 14.7125 7.04404 14.0958 6.63199C13.4792 6.21993 12.7541 6 12.0125 6C11.0179 6 10.0641 6.39508 9.36081 7.09834C8.65755 7.8016 8.26246 8.75544 8.26246 9.75ZM13.7625 9.75C13.7625 10.0961 13.6598 10.4345 13.4675 10.7222C13.2752 11.01 13.0019 11.2343 12.6822 11.3668C12.3624 11.4992 12.0105 11.5339 11.6711 11.4664C11.3316 11.3988 11.0198 11.2322 10.775 10.9874C10.5303 10.7427 10.3636 10.4309 10.2961 10.0914C10.2286 9.75195 10.2632 9.40007 10.3957 9.0803C10.5281 8.76053 10.7524 8.48721 11.0402 8.29492C11.328 8.10263 11.6663 8 12.0125 8C12.4766 8 12.9217 8.18437 13.2499 8.51256C13.5781 8.84074 13.7625 9.28587 13.7625 9.75ZM5.65246 16.83C4.58878 15.4445 4.01228 13.7467 4.01246 12C4.01912 10.1027 4.69991 8.26944 5.93328 6.82766C7.16665 5.38589 8.87231 4.42941 10.7457 4.12899C12.6191 3.82858 14.5383 4.20378 16.1607 5.18762C17.783 6.17146 19.0029 7.69988 19.6025 9.5H21.6825C21.2147 7.68854 20.2482 6.04462 18.8928 4.75506C17.5374 3.46551 15.8474 2.58205 14.0149 2.20509C12.1824 1.82813 10.2809 1.9728 8.52652 2.62265C6.77214 3.27249 5.23524 4.40144 4.0905 5.88121C2.94575 7.36097 2.23907 9.13219 2.05078 10.9936C1.86249 12.8549 2.20013 14.7318 3.02534 16.4108C3.85054 18.0899 5.13021 19.5037 6.7189 20.4918C8.3076 21.4798 10.1416 22.0023 12.0125 22C12.1825 22 12.3425 22 12.5125 22V20C12.3459 20.0099 12.179 20.0099 12.0125 20C10.2792 19.9942 8.59472 19.4257 7.21246 18.38L7.71246 17H12.5125V15H6.31246L5.65246 16.83Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4917 14.0276C21.4917 14.449 21.7079 14.8377 22.059 15.0484L23 15.6103V17.3944L22.0545 17.9563C21.7034 18.167 21.4872 18.5557 21.4872 18.9771L21.4917 20.1103L20.0105 21L19.0695 20.4287C18.7184 20.218 18.2861 20.218 17.935 20.4287L16.994 21L15.5083 20.1103L15.5128 18.9771C15.5128 18.5557 15.2966 18.167 14.9455 17.9563L14 17.3944V15.6103L14.95 15.0437C15.3012 14.833 15.5173 14.4443 15.5173 14.0229L15.5128 12.8897L16.994 12L17.935 12.576C18.2861 12.7867 18.7184 12.7867 19.0695 12.576L20.0105 12.0047L21.4962 12.8944L21.4917 14.0276ZM18.5 17.9062C19.2767 17.9062 19.9062 17.2767 19.9062 16.5C19.9062 15.7233 19.2767 15.0938 18.5 15.0938C17.7233 15.0938 17.0938 15.7233 17.0938 16.5C17.0938 17.2767 17.7233 17.9062 18.5 17.9062Z", fill: "currentColor" })
  );
}

function personOneFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.7001 14H5.30014L2.39014 22H17.3501L16.6201 20.01H11.3301L12.0601 18.01H18.0201L19.4801 22H21.6101L18.7001 14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z", fill: "currentColor" })
  );
}

function personOne(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 12C14.76 12 17 9.76 17 7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7C7 9.76 9.24 12 12 12ZM12 4C13.65 4 15 5.35 15 7C15 8.65 13.65 10 12 10C10.35 10 9 8.65 9 7C9 5.35 10.35 4 12 4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.7001 14H5.30014L2.39014 22H17.3501L16.6201 20H5.24014L6.70014 16H17.3001L19.4801 22H21.6101L18.7001 14Z", fill: "currentColor" })
  );
}

function personGroupFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20.6998 13H13.1198L10.5698 20H19.0298L18.2998 18H15.5198L16.2498 16H19.6998L21.1498 20H23.2498L20.6998 13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3.3 13L0.75 20H8.41L10.96 13H3.3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.5 11.5C9.70914 11.5 11.5 9.70914 11.5 7.5C11.5 5.29086 9.70914 3.5 7.5 3.5C5.29086 3.5 3.5 5.29086 3.5 7.5C3.5 9.70914 5.29086 11.5 7.5 11.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 11.5C19.2091 11.5 21 9.70914 21 7.5C21 5.29086 19.2091 3.5 17 3.5C14.7909 3.5 13 5.29086 13 7.5C13 9.70914 14.7909 11.5 17 11.5Z", fill: "currentColor" })
  );
}

function personGroup(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.23 15L10.96 13H3.3L0.75 20H8.41L9.14 18H3.61L4.7 15H10.23Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.5 11.5C9.71 11.5 11.5 9.71 11.5 7.5C11.5 5.29 9.71 3.5 7.5 3.5C5.29 3.5 3.5 5.29 3.5 7.5C3.5 9.71 5.29 11.5 7.5 11.5ZM7.5 5.5C8.6 5.5 9.5 6.4 9.5 7.5C9.5 8.6 8.6 9.5 7.5 9.5C6.4 9.5 5.5 8.6 5.5 7.5C5.5 6.4 6.4 5.5 7.5 5.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 11.5C19.21 11.5 21 9.71 21 7.5C21 5.29 19.21 3.5 17 3.5C14.79 3.5 13 5.29 13 7.5C13 9.71 14.79 11.5 17 11.5ZM17 5.5C18.1 5.5 19 6.4 19 7.5C19 8.6 18.1 9.5 17 9.5C15.9 9.5 15 8.6 15 7.5C15 6.4 15.9 5.5 17 5.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.6998 13H13.1198L10.5698 20H18.9898L18.2698 18H13.4298L14.5198 15H19.2998L21.1198 20H23.2498L20.6998 13Z", fill: "currentColor" })
  );
}

function personCircleFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C9.4 20 7.1 18.75 5.64 16.83L6.3 15H17.7L18.36 16.83C16.9 18.75 14.6 20 12 20ZM11.99 6.04C14.05 6.04 15.73 7.72 15.73 9.78C15.73 11.84 14.05 13.52 11.99 13.52C9.93 13.52 8.25 11.84 8.25 9.78C8.25 7.72 9.93 6.04 11.99 6.04Z", fill: "currentColor" })
  );
}

function personCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 15.48 3.79 18.54 6.49 20.34L7.7 17H16.3L16.8 18.38C15.46 19.39 13.8 20 12 20C10.92 20 9.9 19.78 8.96 19.4L8.28 21.28C9.43 21.74 10.68 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM18.36 16.83L17.7 15H6.3L5.64 16.83C4.61 15.48 4 13.81 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.81 19.39 15.48 18.36 16.83Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.99 6.03998C9.93 6.03998 8.25 7.71998 8.25 9.77998C8.25 11.84 9.93 13.52 11.99 13.52C14.05 13.52 15.73 11.84 15.73 9.77998C15.73 7.71998 14.05 6.03998 11.99 6.03998ZM11.99 11.52C11.03 11.52 10.25 10.74 10.25 9.77998C10.25 8.81998 11.03 8.03998 11.99 8.03998C12.95 8.03998 13.73 8.81998 13.73 9.77998C13.73 10.74 12.95 11.52 11.99 11.52Z", fill: "currentColor" })
  );
}

function personAddFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.3 13L0.75 20H12.99L12.27 18.01L8.25 18L8.98 16L13.67 16.01L15.12 20H17.25L14.7 13H3.3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 9V6H18V9H15V11H18V14H20V11H23V9H20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z", fill: "currentColor" })
  );
}

function personAdd(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 10V7H18V10H15V12H18V15H20V12H23V10H20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3.3 14L0.75 21H12.99L12.27 19H3.61L4.7 16H13.3L15.12 21H17.25L14.7 14H3.3Z", fill: "currentColor" })
  );
}

function partnerEmbed(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.47 3H6.53H2V5H7.47H16.53H20V19H4V7H2V21H22V3H17.47ZM15.83 15L18.35 12L15.83 9H13.22L15.74 12L13.22 15H15.83ZM8.17001 9L5.64999 12L8.17001 15H10.78L8.26001 12L10.78 9H8.17001Z", fill: "currentColor" })
  );
}

function partnerDashboard(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3V20V21H3H22V19H4V3H2ZM6.04306 16.0393L9.68778 12.3946L13.6645 16.1214L21.9415 7.84439V5.01597L13.6645 13.2929L9.6878 9.56623L6.04309 13.2109L6.04306 16.0393Z", fill: "currentColor" })
  );
}

function navVersionsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: 4, y: 6, width: 16, height: 2, fill: "currentColor" }),
    React.createElement("rect", { x: 5, y: 2, width: 14, height: 2, fill: "currentColor" }),
    React.createElement("rect", { x: 3, y: 10, width: 18, height: 12, fill: "currentColor" })
  );
}

function navVersions(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 2H18V4H6V2Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4 6H20V8H4V6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3 10V18H5V12H19V20H3V22H21V10H3Z", fill: "currentColor" })
  );
}

function navTables(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2.9978H21.0022V7.49897H12V2.9978Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 7.49897L2.99756 7.4989V12.0001H11.9997L12 7.49897Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11.9997 12.0001L21.0022 12V16.5012H12L11.9997 12.0001Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2.99756 16.5011L12 16.5012L11.9997 21.0023H2.99756V16.5011Z", fill: "currentColor" })
  );
}

function navTableFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H11V17H3V21ZM13 15H21V11H13V15ZM3 3V9H21V3H3ZM3 15H11V11H3V15ZM13 21H21V17H13V21Z", fill: "currentColor" })
  );
}

function navTable(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19 5V9H5V7H3V21H21V3H3V5H19ZM5 11H11V14H5V11ZM5 19V16H11V19H5ZM19 19H13V16H19V19ZM19 14H13V11H19V14Z", fill: "currentColor" })
  );
}

function navSearchFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.13405 17.4518L2.2915 20.2943L3.7057 21.7085L6.54825 18.866L5.13405 17.4518Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 19C17.4183 19 21 15.4183 21 11C21 6.58172 17.4183 3 13 3C8.58172 3 5 6.58172 5 11C5 15.4183 8.58172 19 13 19Z", fill: "currentColor" })
  );
}

function navSearch(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.13405 17.4518L2.2915 20.2943L3.7057 21.7085L6.54825 18.866L5.13405 17.4518Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 3C8.59 3 5 6.59 5 11C5 14.75 7.98 19 13 19C17.41 19 21 15.41 21 11C21 6.59 17.41 3 13 3ZM13 17C9.2 17 7 13.79 7 11C7 7.69 9.69 5 13 5C16.31 5 19 7.69 19 11C19 14.31 16.31 17 13 17Z", fill: "currentColor" })
  );
}

function navProjectsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2H22V22H2V2ZM17 13V15C17 16.1046 16.1046 17 15 17H13V13H17ZM11 13H7V15C7 16.1046 7.89543 17 9 17H11V13ZM13 7H15C16.1046 7 17 7.89543 17 9V11H13V7ZM9 7C7.89543 7 7 7.89543 7 9V11H11V7H9Z", fill: "currentColor" })
  );
}

function navProjects(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 13H17V15C17 16.1046 16.1046 17 15 17H13V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7 13H11V17H9C7.89543 17 7 16.1046 7 15V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 7H15C16.1046 7 17 7.89543 17 9V11H13V7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7 9C7 7.89543 7.89543 7 9 7H11V11H7V9Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4V18H4V4H20V20H2V22H20H22V20V4V2H20H4H2V4Z", fill: "currentColor" })
  );
}

function navProductHub(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.75 3.75C2.75 3.19772 3.19772 2.75 3.75 2.75H6.25C6.80228 2.75 7.25 3.19772 7.25 3.75V6.25C7.25 6.80228 6.80228 7.25 6.25 7.25H3.75C3.19772 7.25 2.75 6.80228 2.75 6.25V3.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2.75 10.75C2.75 10.1977 3.19772 9.75 3.75 9.75H6.25C6.80228 9.75 7.25 10.1977 7.25 10.75V13.25C7.25 13.8023 6.80228 14.25 6.25 14.25H3.75C3.19772 14.25 2.75 13.8023 2.75 13.25V10.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3.75 16.75C3.19772 16.75 2.75 17.1977 2.75 17.75V20.25C2.75 20.8023 3.19772 21.25 3.75 21.25H6.25C6.80228 21.25 7.25 20.8023 7.25 20.25V17.75C7.25 17.1977 6.80228 16.75 6.25 16.75H3.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.75 3.75C9.75 3.19772 10.1977 2.75 10.75 2.75H13.25C13.8023 2.75 14.25 3.19772 14.25 3.75V6.25C14.25 6.80228 13.8023 7.25 13.25 7.25H10.75C10.1977 7.25 9.75 6.80228 9.75 6.25V3.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.75 9.75C10.1977 9.75 9.75 10.1977 9.75 10.75V13.25C9.75 13.8023 10.1977 14.25 10.75 14.25H13.25C13.8023 14.25 14.25 13.8023 14.25 13.25V10.75C14.25 10.1977 13.8023 9.75 13.25 9.75H10.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.75 17.75C9.75 17.1977 10.1977 16.75 10.75 16.75H13.25C13.8023 16.75 14.25 17.1977 14.25 17.75V20.25C14.25 20.8023 13.8023 21.25 13.25 21.25H10.75C10.1977 21.25 9.75 20.8023 9.75 20.25V17.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17.75 2.75C17.1977 2.75 16.75 3.19772 16.75 3.75V6.25C16.75 6.80228 17.1977 7.25 17.75 7.25H20.25C20.8023 7.25 21.25 6.80228 21.25 6.25V3.75C21.25 3.19772 20.8023 2.75 20.25 2.75H17.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.75 10.75C16.75 10.1977 17.1977 9.75 17.75 9.75H20.25C20.8023 9.75 21.25 10.1977 21.25 10.75V13.25C21.25 13.8023 20.8023 14.25 20.25 14.25H17.75C17.1977 14.25 16.75 13.8023 16.75 13.25V10.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17.75 16.75C17.1977 16.75 16.75 17.1977 16.75 17.75V20.25C16.75 20.8023 17.1977 21.25 17.75 21.25H20.25C20.8023 21.25 21.25 20.8023 21.25 20.25V17.75C21.25 17.1977 20.8023 16.75 20.25 16.75H17.75Z", fill: "currentColor" })
  );
}

function navMoreVert(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 21.25C13.2426 21.25 14.25 20.2426 14.25 19C14.25 17.7574 13.2426 16.75 12 16.75C10.7574 16.75 9.75 17.7574 9.75 19C9.75 20.2426 10.7574 21.25 12 21.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 7.25C13.2426 7.25 14.25 6.24264 14.25 5C14.25 3.75736 13.2426 2.75 12 2.75C10.7574 2.75 9.75 3.75736 9.75 5C9.75 6.24264 10.7574 7.25 12 7.25Z", fill: "currentColor" })
  );
}

function navMoreHoriz(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M5 14.25C6.24264 14.25 7.25 13.2426 7.25 12C7.25 10.7574 6.24264 9.75 5 9.75C3.75736 9.75 2.75 10.7574 2.75 12C2.75 13.2426 3.75736 14.25 5 14.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19 14.25C20.2426 14.25 21.25 13.2426 21.25 12C21.25 10.7574 20.2426 9.75 19 9.75C17.7574 9.75 16.75 10.7574 16.75 12C16.75 13.2426 17.7574 14.25 19 14.25Z", fill: "currentColor" })
  );
}

function navMenuAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 5H4V7H20V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4 14.4299L20 11.5999V9.56995L4 12.3999V14.4299Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 17H4V19H20V17Z", fill: "currentColor" })
  );
}

function navMenu(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 6H4V8H20V6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 11H4V13H20V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 16H4V18H20V16Z", fill: "currentColor" })
  );
}

function navMCP(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.2091 2.89482C12.5739 1.66158 14.6812 1.70328 15.9966 3.01865L16.1195 3.14783C16.8341 3.9385 17.1201 4.9777 16.9792 5.9683C18.0252 5.81917 19.1258 6.1472 19.9306 6.95182L19.9725 6.9928C21.2877 8.30807 21.3284 10.4146 20.0954 11.7794L19.9716 11.9095L12.8572 19.0239C12.767 19.1143 12.767 19.2613 12.8572 19.3517L14.3182 20.8128L14.3654 20.8662C14.588 21.1393 14.5725 21.5417 14.3182 21.7963C14.0636 22.0506 13.6602 22.067 13.3872 21.8444L13.3347 21.7963L11.8736 20.3353C11.2403 19.7018 11.2405 18.6748 11.8736 18.0413L18.9881 10.926L19.1315 10.7674C19.7554 10.0026 19.7555 8.89875 19.1315 8.13399L18.989 7.97542L18.948 7.93444L18.7894 7.7919C18.0246 7.16816 16.9208 7.16814 16.156 7.7919L15.9966 7.93444L10.0554 13.8765C9.78381 14.1475 9.34327 14.1479 9.07188 13.8765C8.80054 13.6051 8.80084 13.1646 9.07188 12.893L15.013 6.95182L15.1565 6.79324C15.7802 6.02848 15.7803 4.92454 15.1565 4.15985L15.013 4.00128C14.2494 3.23786 13.0413 3.19061 12.222 3.85874L12.0634 4.00128L4.19619 11.8685C3.9246 12.1396 3.48409 12.1399 3.21267 11.8685C2.94139 11.5971 2.94157 11.1565 3.21267 10.885L11.0799 3.01865L11.2091 2.89482Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.0995 4.93668C13.3725 4.71424 13.775 4.73051 14.0295 4.98479C14.301 5.25635 14.301 5.69679 14.0295 5.9683L8.21131 11.7865C7.39697 12.6011 7.39671 13.9224 8.21131 14.7371L8.36988 14.8796C9.18913 15.5479 10.398 15.5005 11.1618 14.7371L16.9801 8.91795C17.2516 8.64664 17.6921 8.6466 17.9636 8.91795C18.235 9.18945 18.2349 9.62994 17.9636 9.90146L12.1454 15.7197C10.8301 17.0348 8.72262 17.0764 7.35786 15.8435L7.22868 15.7197C5.87101 14.3619 5.87102 12.1607 7.22868 10.803L13.0469 4.98479L13.0995 4.93668Z", fill: "currentColor" })
  );
}

function navInterfaces(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.49989 7.50049V16.5001L16.4999 16.5001V21H3.00022L3 3H20.9999V16.5001L16.4999 16.5001L16.5 7.50049L7.49989 7.50049Z", fill: "currentColor" })
  );
}

function navIntegrationsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.21 1.5H7.79001L6.53 3H2V21H22V3H17.47L16.21 1.5ZM18.35 12L15.83 15H13.22L15.74 12L13.22 9H15.83L18.35 12ZM10.78 9L8.26001 12L10.78 15H8.17001L5.64999 12L8.17001 9H10.78Z", fill: "currentColor" })
  );
}

function navIntegrations(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.47 3L16.21 1.5H7.79001L6.53 3H2V5H7.47L8.72 3.5H15.28L16.53 5H20V19H4V7H2V21H22V3H17.47ZM15.83 15L18.35 12L15.83 9H13.22L15.74 12L13.22 15H15.83ZM8.17001 9L5.64999 12L8.17001 15H10.78L8.26001 12L10.78 9H8.17001Z", fill: "currentColor" })
  );
}

function navHomeFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 10.35L23 11.5V9.19998L21 8.03998L20.93 7.99998H21V4.99998H19V6.87998L12 2.84998L1 9.19998V11.5L3 10.35V21H21V10.35Z", fill: "currentColor" })
  );
}

function navHome(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 5.15998L23 11.5V9.19998L21 8.03998V4.99998H19V6.88998L12 2.84998L1 9.19998V11.5L3 10.35V21H21V12.67L19 11.51V19H5V9.19998L12 5.15998Z", fill: "currentColor" })
  );
}

function navHelpFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12ZM12.01 18.25C11.32 18.25 10.76 17.69 10.76 17C10.76 16.31 11.32 15.75 12.01 15.75C12.7 15.75 13.26 16.31 13.26 17C13.26 17.69 12.7 18.25 12.01 18.25ZM12.36 6.13C14.44 6.15 16.06 7.4 16.22 9.09C16.35 10.43 15.52 12.06 12.88 12.82V14.5H11.13L11.12 11.42L11.82 11.28C13.51 10.93 14.56 10.14 14.47 9.27C14.41 8.61 13.64 7.9 12.33 7.89C12.31 7.89 12.3 7.89 12.28 7.89C11.01 7.89 9.99 8.39 9.36 8.79V6.8C10.14 6.44 11.12 6.14 12.28 6.14C12.31 6.13 12.33 6.13 12.36 6.13Z", fill: "currentColor" })
  );
}

function navHelp(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.0098 18.25C12.7001 18.25 13.2598 17.6904 13.2598 17C13.2598 16.3096 12.7001 15.75 12.0098 15.75C11.3194 15.75 10.7598 16.3096 10.7598 17C10.7598 17.6904 11.3194 18.25 12.0098 18.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.3599 6.13C11.1799 6.12 10.1699 6.43 9.37988 6.8V8.78C9.99988 8.38 11.0299 7.88 12.2999 7.88C12.3199 7.88 12.3299 7.88 12.3499 7.88C13.6499 7.89 14.4199 8.6 14.4899 9.26C14.5699 10.14 13.5299 10.93 11.8399 11.27L11.1399 11.41L11.1499 14.49H12.8999V12.81C15.5399 12.05 16.3699 10.43 16.2399 9.08C16.0599 7.4 14.4299 6.15 12.3599 6.13Z", fill: "currentColor" })
  );
}

function navGridView(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 11H3V3H11V11ZM9 5H5V9H9V5Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 21H3V13H11V21ZM9 15H5V19H9V15Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 21H21V13H13V21ZM15 15H19V19H15V15Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 11H13V3H21V11ZM19 5H15V9H19V5Z", fill: "currentColor" })
  );
}

function navFunctions(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.57167 12L11.1167 16.545L7.58167 20.0817L2 14.5V9.5L9.5 2H14.5L15.535 3.035L6.57167 12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.8832 7.45504L16.4198 3.92004L21.9998 9.50004V14.5L14.4998 22H9.49984L8.46484 20.965L17.4282 12L12.8832 7.45504Z", fill: "currentColor" })
  );
}

function navFolderFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 5H12.47L10.79 3H2V21H22V5Z", fill: "currentColor" })
  );
}

function navFolder(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 5H9.86L11.53 7H20V19H2V21H22V5H12.47L10.79 3H2V17H4V5Z", fill: "currentColor" })
  );
}

function navExploreFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.0498 12.97C2.4398 16.97 5.1898 20.28 8.8898 21.5L5.7898 12.98L2.0498 12.97Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.91992 12.98L11.1899 21.96C11.8599 22.01 12.1299 22.02 12.8099 21.96L16.0699 12.99L7.91992 12.98Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.1099 21.5C18.7999 20.29 21.5599 16.99 21.9499 13H18.1999L15.1099 21.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.9499 11C21.5499 7.01 18.7999 3.71 15.1099 2.5L18.1999 11H21.9499Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.0699 10.99L12.8099 2.03999C12.1399 1.98999 11.8699 1.97999 11.1899 2.03999L7.93994 10.98L16.0699 10.99Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.8898 2.5C5.2098 3.71 2.4598 7 2.0498 10.97H5.7998L8.8898 2.5Z", fill: "currentColor" })
  );
}

function navExplore(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.0002 2C7.53017 2 3.74017 4.95 2.46017 9H4.59017C5.42017 6.96 7.07017 5.34 9.13017 4.54L6.78017 11H2.05017C1.46017 16.89 6.10017 22 12.0002 22C17.5102 22 22.0002 17.51 22.0002 12C22.0002 6.49 17.5102 2 12.0002 2ZM11.4402 4.03C12.0102 3.99 12.0102 3.99 12.5302 4.03L15.0702 11H8.90017L11.4402 4.03ZM4.07017 13H6.78017L9.13017 19.46C6.43017 18.41 4.44017 15.96 4.07017 13ZM11.4402 19.97L8.90017 13H15.0702L12.5302 19.97C12.0202 20.01 12.0102 20.01 11.4402 19.97ZM14.8502 19.47L17.2002 13H19.9302C19.5602 15.97 17.5502 18.43 14.8502 19.47ZM17.2002 11L14.8502 4.53C17.5602 5.57 19.5602 8.03 19.9302 11H17.2002Z", fill: "currentColor" })
  );
}

function navDashboardFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 15V22H7.29999L9.84 15H2ZM14.58 2H2V13H10.57L14.58 2ZM9.42001 22H22V11H13.43L9.42001 22ZM16.7 2L14.16 9H22V2H16.7Z", fill: "currentColor" })
  );
}

function navDashboard(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.85 4L10.57 13H4V6H2V22H22V2H2V4H13.85ZM4 15H9.84L8 20H4V15ZM10.15 20L13.43 11H20V20H10.15ZM20 9H14.16L15.98 4H19.98L20 9Z", fill: "currentColor" })
  );
}

function navCustomAction(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.0015 2.03076C6.50868 2.03076 2.03271 6.50673 2.03271 11.9995C2.03271 17.4923 6.50868 21.9683 12.0015 21.9683C13.476 21.9683 14.8773 21.6457 16.1383 21.0675L16.0694 20.9435L13.9834 19.7251C13.3494 19.8879 12.6853 19.9745 12.0015 19.9745C7.60525 19.9745 4.02646 16.3957 4.02646 11.9995C4.02646 7.60329 7.60525 4.02451 12.0015 4.02451C16.3977 4.02451 19.9765 7.60329 19.9765 11.9995C19.9765 12.6336 19.902 13.2507 19.7614 13.8426L21.0194 16.0123L21.1039 16.0605C21.6604 14.8192 21.9702 13.4445 21.9702 11.9995C21.9702 6.50673 17.4942 2.03076 12.0015 2.03076Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.0039 15.9873V12.9873H16.0133V10.9873H13.0039V7.9873H10.9977V10.9873H7.98828V12.9873H10.9977V15.9873H13.0039Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.7985 17.1984L18.5178 14.996L17.2371 17.1984L15.0347 18.4791L17.2371 19.7598L18.5178 21.9622L19.7985 19.7598L22.0009 18.4791L19.7985 17.1984Z", fill: "currentColor" })
  );
}

function navConnectedAssetsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 7C21 9.20914 19.2091 11 17 11C14.7909 11 13 9.20914 13 7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21ZM17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11ZM7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.452 14.9778C10.8003 15.5711 11 16.2622 11 16.9999C11 19.209 9.20914 20.9999 7 20.9999C4.79086 20.9999 3 19.209 3 16.9999C3 14.7907 4.79086 12.9999 7 12.9999C7.74592 12.9999 8.44416 13.2041 9.04187 13.5596L12.4648 10.1366L13.8791 11.5508L10.452 14.9778Z", fill: "currentColor" })
  );
}

function navConnectedAssets(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11ZM17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21ZM17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11ZM7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.452 14.9778C10.8003 15.5711 11 16.2622 11 16.9999C11 19.209 9.20914 20.9999 7 20.9999C4.79086 20.9999 3 19.209 3 16.9999C3 14.7907 4.79086 12.9999 7 12.9999C7.74592 12.9999 8.44416 13.2041 9.04187 13.5596L12.4609 10.1405L13.8752 11.5547L10.452 14.9778ZM9 16.9999C9 18.1044 8.10457 18.9999 7 18.9999C5.89543 18.9999 5 18.1044 5 16.9999C5 15.8953 5.89543 14.9999 7 14.9999C8.10457 14.9999 9 15.8953 9 16.9999Z", fill: "currentColor" })
  );
}

function navCogFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.9 8.90001C19.12 8.45001 18.64 7.62001 18.64 6.72001L18.65 4.30001L15.35 2.40001L13.26 3.62001C12.48 4.07001 11.52 4.07001 10.74 3.62001L8.65 2.39001L5.36 4.29001L5.37 6.71001C5.37 7.61001 4.89 8.44001 4.11 8.89001L2 10.1V13.91L4.1 15.11C4.88 15.56 5.36 16.39 5.36 17.29L5.35 19.71L8.65 21.61L10.74 20.39C11.52 19.94 12.48 19.94 13.26 20.39L15.35 21.61L18.64 19.71L18.63 17.29C18.63 16.39 19.11 15.56 19.89 15.11L21.99 13.91V10.1L19.9 8.90001ZM12 16C9.79 16 8 14.21 8 12C8 9.79001 9.79 8.00001 12 8.00001C14.21 8.00001 16 9.79001 16 12C16 14.21 14.21 16 12 16Z", fill: "currentColor" })
  );
}

function navCog(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.9 8.90001C19.12 8.45001 18.64 7.62001 18.64 6.72001L18.65 4.30001L15.36 2.40001L13.27 3.62001C12.49 4.07001 11.53 4.07001 10.75 3.62001L8.65 2.39001L5.36 4.29001L5.37 6.71001C5.37 7.61001 4.89 8.44001 4.11 8.89001L2 10.1V13.91L4.1 15.11C4.88 15.56 5.36 16.39 5.36 17.29L5.35 18.92L7.36 17.74V17.3C7.37 15.68 6.5 14.18 5.09 13.37L4 12.74V11.26L5.1 10.63C6.51 9.83001 7.38 8.32001 7.37 6.70001V5.44001L8.64 4.70001L9.73 5.34001C11.13 6.16001 12.87 6.16001 14.27 5.34001L15.36 4.70001L16.64 5.44001V6.70001C16.63 8.32001 17.5 9.82001 18.91 10.63L20.01 11.26V12.74L18.91 13.37C17.5 14.17 16.63 15.68 16.64 17.3V18.56L15.36 19.3L14.27 18.66C13.57 18.25 12.79 18.05 12 18.05C11.21 18.05 10.43 18.25 9.73 18.66L6.66 20.46L8.65 21.61L10.74 20.39C11.52 19.94 12.48 19.94 13.26 20.39L15.35 21.61L18.64 19.71L18.63 17.29C18.63 16.39 19.11 15.56 19.89 15.11L21.99 13.91V10.1L19.9 8.90001Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5Z", fill: "currentColor" })
  );
}

function navCentral(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_36933_10681)" },
      React.createElement("rect", { x: 3, y: 3, width: 4.5, height: 4.5, fill: "currentColor" }),
      React.createElement("rect", { x: 16.5, y: 3, width: 4.5, height: 4.5, fill: "currentColor" }),
      React.createElement("rect", { x: 16.5, y: 16.5001, width: 4.5, height: 4.5, fill: "currentColor" }),
      React.createElement("rect", { x: 3, y: 16.5001, width: 4.5, height: 4.5, fill: "currentColor" }),
      React.createElement("rect", { x: 7.50049, y: 7.49988, width: 9, height: 9, fill: "currentColor" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_36933_10681" },
        React.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(3 3)" })
      )
    )
  );
}

function navCanvas(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 3H3V7.5H16.5V21H21V3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.2498 11.9999C14.2498 13.2426 13.2424 14.25 11.9998 14.25C10.7572 14.25 9.74981 13.2426 9.74981 11.9999C9.74981 10.7573 10.7572 9.74993 11.9998 9.74993C13.2424 9.74993 14.2498 10.7573 14.2498 11.9999Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.74981 16.5001C9.74981 17.7427 8.74245 18.7501 7.49981 18.7501C6.25717 18.7501 5.24981 17.7427 5.24981 16.5001C5.24981 15.2574 6.25717 14.2501 7.49981 14.2501C8.74245 14.2501 9.74981 15.2574 9.74981 16.5001Z", fill: "currentColor" })
  );
}

function navBriefcaseFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.47 6L14.95 3H9.05L6.53 6H2V14H11V12H13V14H22V6H17.47ZM9.14 6L9.98 5H14.01L14.85 6H9.14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 17H11V16H2V21H22V16H13V17Z", fill: "currentColor" })
  );
}

function navBriefcase(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 6H17.47L14.95 3H9.05L6.53 6H2V8H20V14H13V12H11V14H4V10H2V21H22V6ZM9.14 6L9.98 5H14.01L14.85 6H9.14ZM20 19H4V16H11V17H13V16H20V19Z", fill: "currentColor" })
  );
}

function navBlogFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 4H14V20H22V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 4H2V12H12V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 14H2V16H12V14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 18H2V20H12V18Z", fill: "currentColor" })
  );
}

function navBlog(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14 4V20H22V4H14ZM20 18H16V6H20V18Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 12H12V4H2V12ZM4 6H10V10H4V6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 14H2V16H12V14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 18H2V20H12V18Z", fill: "currentColor" })
  );
}

function navBellFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9998 22.5C13.2098 22.5 14.2198 21.64 14.4498 20.5H9.5498C9.7798 21.64 10.7898 22.5 11.9998 22.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.73 14.94L19.27 8.75C18.99 4.96 15.79 2 12 2C8.21 2 5.01 4.96 4.73 8.75L4.27 14.94L2.5 17.04V19H21.5V17.04L19.73 14.94Z", fill: "currentColor" })
  );
}

function navBell(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.72 8.9C6.93 6.15 9.25 4 12 4C14.75 4 17.07 6.15 17.28 8.9L17.79 15.73L18.86 17H2.53L2.5 17.04V19H9.5C9.5 20.38 10.62 21.5 12 21.5C13.38 21.5 14.5 20.38 14.5 19H21.5V17.04L19.73 14.94L19.27 8.75C18.99 4.96 15.79 2 12 2C8.21 2 5.01 4.96 4.73 8.75L4.27 14.94L4.21 15H6.26L6.72 8.9Z", fill: "currentColor" })
  );
}

function navAppsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 3H3V11H11V3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11 13H3V21H11V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 13H13V21H21V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 6V3H16V6H13V8H16V11H18V8H21V6H18Z", fill: "currentColor" })
  );
}

function navApps(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 11H11V3H3V11ZM5 5H9V9H5V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3 21H11V13H3V21ZM5 15H9V19H5V15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 21H21V13H13V21ZM15 15H19V19H15V15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 6V3H16V6H13V8H16V11H18V8H21V6H18Z", fill: "currentColor" })
  );
}

function navAIChatbot(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.99999 2H2V6.99999H6.99999V2Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.9997 12H2.00049V17H21.9997V12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.9997 12L7 12L6.99999 6.99999L12 7V2H22L21.9997 12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M6.99951 22V17H11.9995L6.99951 22Z", fill: "currentColor" })
  );
}

function miscWorldFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.0498 12.97C2.4398 16.97 5.1898 20.28 8.8898 21.5L5.7898 12.98L2.0498 12.97Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.91992 12.98L11.1899 21.96C11.8599 22.01 12.1299 22.02 12.8099 21.96L16.0699 12.99L7.91992 12.98Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.1099 21.5C18.7999 20.29 21.5599 16.99 21.9499 13H18.1999L15.1099 21.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.9499 11C21.5499 7.01 18.7999 3.71 15.1099 2.5L18.1999 11H21.9499Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.0699 10.99L12.8099 2.03999C12.1399 1.98999 11.8699 1.97999 11.1899 2.03999L7.93994 10.98L16.0699 10.99Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.8898 2.5C5.2098 3.71 2.4598 7 2.0498 10.97H5.7998L8.8898 2.5Z", fill: "currentColor" })
  );
}

function miscWorld(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.0002 2C7.53017 2 3.74017 4.95 2.46017 9H4.59017C5.42017 6.96 7.07017 5.34 9.13017 4.54L6.78017 11H2.05017C1.46017 16.89 6.10017 22 12.0002 22C17.5102 22 22.0002 17.51 22.0002 12C22.0002 6.49 17.5102 2 12.0002 2ZM11.4402 4.03C12.0102 3.99 12.0102 3.99 12.5302 4.03L15.0702 11H8.90017L11.4402 4.03ZM4.07017 13H6.78017L9.13017 19.46C6.43017 18.41 4.44017 15.96 4.07017 13ZM11.4402 19.97L8.90017 13H15.0702L12.5302 19.97C12.0202 20.01 12.0102 20.01 11.4402 19.97ZM14.8502 19.47L17.2002 13H19.9302C19.5602 15.97 17.5502 18.43 14.8502 19.47ZM17.2002 11L14.8502 4.53C17.5602 5.57 19.5602 8.03 19.9302 11H17.2002Z", fill: "currentColor" })
  );
}

function miscWalletFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 4V2H2V19C2 20.65 3.35 22 5 22H22V6H5C4.46 6 4 5.57 4 5V4H20ZM16 11.75C17.24 11.75 18.25 12.76 18.25 14C18.25 15.24 17.24 16.25 16 16.25C14.76 16.25 13.75 15.24 13.75 14C13.75 12.76 14.76 11.75 16 11.75Z", fill: "currentColor" })
  );
}

function miscWallet(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 6C4.59 6 4 5.68 4 5V4H20V2H2V19C2 20.65 3.35 22 5 22H22V6H5ZM20 20H5C4.45 20 4 19.55 4 19V7.83C4.32 7.94 4.66 8 5 8H20V20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 16.25C17.2426 16.25 18.25 15.2426 18.25 14C18.25 12.7574 17.2426 11.75 16 11.75C14.7574 11.75 13.75 12.7574 13.75 14C13.75 15.2426 14.7574 16.25 16 16.25Z", fill: "currentColor" })
  );
}

function miscUptimeFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 11H21.95C21.45 5.95 17.18 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C12.34 22 12.67 21.98 13 21.95V15.32L18 11ZM9.18 15.76L7.87 14.25L11 11.55V7H13V12.46L9.18 15.76Z", fill: "currentColor" }),
    React.createElement("path", { d: "M22.0002 11C21.8068 9.07668 21.0602 7.25054 19.8506 5.7427C18.641 4.23487 17.0204 3.10995 15.1847 2.50406C13.3491 1.89816 11.3772 1.83727 9.5077 2.32876C7.63819 2.82026 5.9512 3.84313 4.6509 5.27346C3.35059 6.7038 2.49272 8.48033 2.1811 10.3881C1.86947 12.2958 2.11746 14.253 2.89504 16.0227C3.67263 17.7925 4.94648 19.2989 6.56242 20.3598C8.17837 21.4206 10.0671 21.9903 12.0002 22C12.3402 22 12.6702 22 13.0002 22V15.25L18.0002 11.0501L22.0002 11ZM13.0002 12.47L9.07016 15.77L7.78016 14.24L11.0002 11.5301V7.00003H13.0002V12.47ZM19.0002 13.02L15.0002 16.38V18.38L18.2502 15.6501V22H19.7502V15.61L23.0002 18.34V16.34L19.0002 13.02Z", fill: "currentColor" })
  );
}

function miscUptime(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.99998 12C3.99998 9.87827 4.84284 7.84343 6.34313 6.34314C7.84342 4.84285 9.87825 4 12 4C13.9473 4.00177 15.8271 4.71377 17.287 6.00244C18.7468 7.29112 19.6866 9.06798 19.93 11H21.93C21.6821 8.53337 20.5268 6.24673 18.6883 4.58374C16.8497 2.92075 14.459 1.99997 11.98 2C9.32782 2 6.78428 3.05359 4.90891 4.92896C3.03355 6.80432 1.97998 9.34784 1.97998 12C1.97998 14.6522 3.03355 17.1957 4.90891 19.071C6.78428 20.9464 9.32782 22 11.98 22C12.32 22 12.65 22 12.98 22V20C12.6484 20.0436 12.3144 20.0669 11.98 20.0699C10.9252 20.0674 9.88129 19.8562 8.90841 19.4486C7.93553 19.041 7.05286 18.4451 6.31119 17.6951C5.56952 16.945 4.9835 16.0558 4.58685 15.0784C4.19019 14.101 3.99075 13.0548 3.99998 12ZM11 11.54L7.86998 14.24L9.17998 15.76L13 12.46V7H11V11.54ZM19 13.02L15 16.38V18.38L18.25 15.65V22H19.75V15.61L23 18.34V16.34L19 13.02Z", fill: "currentColor" })
  );
}

function miscTrigger(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.3725 12.0909H13.9034V13.6383H8.03174L17.0183 3V10.5435H21.3325L12.3459 21.1818V15.1857H13.9034V16.9265L17.9917 12.0909H15.4608V7.25532L11.3725 12.0909Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 13.4174H7.33987V12.4174H2V13.4174Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.6773 16.07L2.66748 16.07L2.66748 15.07L10.6773 15.07V16.07Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.00244 10.7647L9.34231 10.7647V9.76468L4.00244 9.76468V10.7647Z", fill: "currentColor" })
  );
}

function miscTimelapse(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 20C9.87827 20 7.84344 19.1572 6.34315 17.6569C4.84286 16.1566 4 14.1217 4 12C4 9.87827 4.84286 7.84343 6.34315 6.34314C7.84344 4.84285 9.87827 4 12 4V2C9.34784 2 6.8043 3.05359 4.92893 4.92896C3.05357 6.80432 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.071C5.85752 19.9996 6.95991 20.7362 8.17316 21.2388C9.38642 21.7413 10.6868 22 12 22C14.3302 22.001 16.5877 21.1882 18.3824 19.702C20.1772 18.2158 21.3966 16.1495 21.83 13.86L19.83 13.49C19.4839 15.3155 18.5132 16.9637 17.0845 18.1516C15.6557 19.3395 13.8581 19.993 12 20ZM14.57 4.42004C14.7236 4.47741 14.887 4.50364 15.0508 4.49744C15.2146 4.49123 15.3756 4.45261 15.5244 4.38379C15.6732 4.31497 15.8069 4.21737 15.9177 4.09656C16.0285 3.97574 16.1143 3.83422 16.17 3.68005C16.2274 3.52648 16.2537 3.36304 16.2475 3.19922C16.2413 3.0354 16.2027 2.87438 16.1338 2.72559C16.065 2.57679 15.9674 2.44309 15.8466 2.33228C15.7258 2.22146 15.5842 2.1357 15.43 2.07996C15.2764 2.02259 15.113 1.99636 14.9492 2.00256C14.7854 2.00877 14.6244 2.04739 14.4756 2.11621C14.3268 2.18503 14.1931 2.28263 14.0823 2.40344C13.9715 2.52426 13.8857 2.66578 13.83 2.81995C13.7726 2.97352 13.7463 3.13696 13.7525 3.30078C13.7587 3.4646 13.7973 3.62562 13.8662 3.77441C13.935 3.92321 14.0326 4.05691 14.1534 4.16772C14.2742 4.27854 14.4158 4.3643 14.57 4.42004ZM19.62 6.82996C19.7627 6.74808 19.8878 6.63888 19.9882 6.50854C20.0886 6.37821 20.1623 6.22942 20.205 6.07056C20.2477 5.91169 20.2587 5.74587 20.2372 5.58276C20.2158 5.41966 20.1624 5.26241 20.08 5.12C19.9983 4.97848 19.8893 4.85453 19.7595 4.75525C19.6297 4.65597 19.4816 4.58332 19.3236 4.5415C19.1656 4.49968 19.0009 4.48955 18.839 4.5116C18.677 4.53365 18.5211 4.58751 18.38 4.67004C18.2373 4.75192 18.1122 4.86112 18.0118 4.99146C17.9114 5.12179 17.8377 5.27058 17.795 5.42944C17.7523 5.58831 17.7413 5.75413 17.7628 5.91724C17.7842 6.08034 17.8376 6.23759 17.92 6.38C18.0017 6.52152 18.1107 6.64547 18.2405 6.74475C18.3703 6.84403 18.5184 6.91668 18.6764 6.9585C18.8344 7.00032 18.9991 7.01045 19.161 6.9884C19.323 6.96635 19.4789 6.91249 19.62 6.82996ZM19.52 10.72C19.5808 11.0443 19.7673 11.3315 20.0389 11.5188C20.3106 11.7061 20.6453 11.7784 20.97 11.72C21.2943 11.6592 21.5814 11.4727 21.7688 11.201C21.9561 10.9294 22.0284 10.5948 21.97 10.27C21.9092 9.9457 21.7227 9.65852 21.4511 9.47119C21.1794 9.28386 20.8447 9.21158 20.52 9.27002C20.1957 9.3308 19.9086 9.51731 19.7212 9.78894C19.5339 10.0606 19.4616 10.3952 19.52 10.72ZM11 11.53L7.78 14.24L9.07 15.77L13 12.47V7H11V11.53Z", fill: "currentColor" })
  );
}

function miscStepsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 8H8V13H3V21H21V3H13V8Z", fill: "currentColor" })
  );
}

function miscStepsAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 5H12V7H21V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 11H8V13H17V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17H3V19H12V17Z", fill: "currentColor" })
  );
}

function miscSteps3(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.0103 5H11.0103V7H21.0103V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.0103 11H11.0103V13H21.0103V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.0103 17H11.0103V19H21.0103V17Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.8 8.00001H5.75V4.20001L4 4.93001V5.85001L4.8 5.50001V8.00001Z", fill: "currentColor" }),
    React.createElement("path", { d: "M6.54006 13.22H5.43006L5.90006 12.61C6.23006 12.17 6.45006 11.83 6.45006 11.4C6.45006 10.76 5.94006 10.29 5.22006 10.29C4.74006 10.29 4.31006 10.48 4.04006 10.71V11.61C4.26006 11.42 4.69006 11.15 5.06006 11.15C5.35006 11.15 5.50006 11.29 5.50006 11.53C5.50006 11.82 5.17006 12.22 4.85006 12.65L3.81006 14H6.54006V13.22Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.10027 16.29V17.07H5.25027L4.61027 18.18C5.16027 18.22 5.60027 18.37 5.60027 18.76C5.60027 19.05 5.33027 19.23 5.00027 19.23C4.66027 19.23 4.31027 19.08 4.03027 18.83V19.71C4.29027 19.87 4.59027 20 5.09027 20C5.82027 20 6.50027 19.54 6.50027 18.75C6.50027 18.31 6.25027 17.89 5.79027 17.72L6.60027 16.28H4.10027V16.29Z", fill: "currentColor" })
  );
}

function miscSteps2(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 5H11V7H21V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 11H11V13H21V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 17H11V19H21V17Z", fill: "currentColor" }),
    React.createElement("path", { d: "M5.49004 10H6.63004V5.44L4.54004 6.32V7.42L5.49004 7V10Z", fill: "currentColor" }),
    React.createElement("path", { d: "M6.75 15.33C7.15 14.81 7.4 14.4 7.4 13.88C7.4 13.11 6.79 12.55 5.93 12.55C5.36 12.55 4.85 12.78 4.52 13.05V14.13C4.79 13.9 5.3 13.57 5.74 13.57C6.09 13.57 6.26 13.74 6.26 14.02C6.26 14.36 5.87 14.85 5.49 15.36L4.25 17H7.52V16.06H6.19L6.75 15.33Z", fill: "currentColor" })
  );
}

function miscSteps1(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 10.78L5 10.28V17H7V7.72L3 8.72V10.78Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 5H12V7H21V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 11H12V13H21V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 17H12V19H21V17Z", fill: "currentColor" })
  );
}

function miscSteps(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 17.09V21.09H21V3.08997H13V8.08997H8V13.09H3V15.09H10V10.09H15V5.08997H19V19.09H5V17.09H3Z", fill: "currentColor" })
  );
}

function miscSecurityFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 1.91H3V9.91C3 17.37 7.63 20.34 12 22.53C16.38 20.34 21 17.37 21 9.91V1.91ZM11.5 14.33L8.29 11.12L9.71 9.7L11.5 11.49L15.29 7.7L16.7 9.11L11.5 14.33Z", fill: "currentColor" })
  );
}

function miscSecurity(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 2V4H19V10C19 14.81 17.03 17.76 12 20.38C6.97 17.76 5 14.81 5 10V6H3V10C3 17.46 7.63 20.43 12 22.62C16.38 20.43 21 17.46 21 10V2H3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.29 7.78999L11.5 11.59L9.71004 9.78999L8.29004 11.21L11.5 14.41L16.71 9.20999L15.29 7.78999Z", fill: "currentColor" })
  );
}

function miscPinFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C7.59 2 4 5.59 4 10C4 14.55 7.28 17.72 12 21.83C16.8 17.65 20 14.53 20 10C20 5.59 16.41 2 12 2ZM12 12.5C10.62 12.5 9.5 11.38 9.5 10C9.5 8.62 10.62 7.5 12 7.5C13.38 7.5 14.5 8.62 14.5 10C14.5 11.38 13.38 12.5 12 12.5Z", fill: "currentColor" })
  );
}

function miscPin(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.5 10C15.5 8.07 13.93 6.5 12 6.5C10.07 6.5 8.5 8.07 8.5 10C8.5 11.93 10.07 13.5 12 13.5C13.93 13.5 15.5 11.93 15.5 10ZM10.5 10C10.5 9.17 11.17 8.5 12 8.5C12.83 8.5 13.5 9.17 13.5 10C13.5 10.83 12.83 11.5 12 11.5C11.17 11.5 10.5 10.83 10.5 10Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C7.59 2 4 5.59 4 10C4 13.58 6.12 16.38 9.01 19.15L10.52 17.82C7.52 14.97 6 12.74 6 10C6 6.69 8.69 4 12 4C15.31 4 18 6.69 18 10C18 13.17 15.98 15.64 12 19.17L10.49 20.51C10.77 20.76 12 21.83 12 21.83C16.8 17.65 20 14.53 20 10C20 5.59 16.41 2 12 2Z", fill: "currentColor" })
  );
}

function miscPieFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.0498 12.91C2.2798 15.22 3.3098 17.3 4.8398 18.88L9.8498 12.91H2.0498Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.1496 4.94L6.36963 20.17C7.96963 21.27 9.90963 21.91 11.9996 21.91C17.5096 21.91 21.9996 17.42 21.9996 11.91C21.9996 9.2 20.9096 6.74 19.1496 4.94Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17.6298 3.65C16.0298 2.55 14.0898 1.91 11.9998 1.91C6.8198 1.91 2.5498 5.86 2.0498 10.91H11.5298L17.6298 3.65Z", fill: "currentColor" })
  );
}

function miscPie(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.0001 2C6.11007 2 1.46007 7.1 2.05007 13H9.86007L6.14007 17.43C5.49007 16.72 4.96007 15.9 4.59007 15H2.46007C3.74007 19.05 7.53007 22 12.0001 22C17.5101 22 22.0001 17.51 22.0001 12C22.0001 6.49 17.5101 2 12.0001 2ZM4.07007 11C4.56007 7.06 7.93007 4 12.0001 4C13.6001 4 15.0801 4.48 16.3301 5.28L11.5301 11H4.07007ZM12.0001 20C10.4001 20 8.92007 19.52 7.67007 18.72L17.8601 6.57C19.1801 8 20.0001 9.9 20.0001 12C20.0001 16.41 16.4101 20 12.0001 20Z", fill: "currentColor" })
  );
}

function miscPackage(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 9H22V3H2V9H19V18.9961H5V11H3V20.9961H21V9ZM4.22222 5V7H19.7778V5H4.22222Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 13L9 13V11H15V13Z", fill: "currentColor" })
  );
}

function miscMicFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 5.91C16 3.7 14.21 1.91 12 1.91C9.79 1.91 8 3.7 8 5.91V14.91H16V5.91Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 10.91V14.67C18 15.9 17 16.91 15.76 16.91H8.24C7 16.91 6 15.91 6 14.67V10.91H4V14.67C4 17.01 5.9 18.91 8.24 18.91H11V21.91H13V18.91H15.76C18.1 18.91 20 17.01 20 14.67V10.91H18Z", fill: "currentColor" })
  );
}

function miscMic(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V15H16V6ZM14 13H10V6C10 4.9 10.9 4 12 4C13.1 4 14 4.9 14 6V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 11V14.76C18 16 17 17 15.76 17H8.24C7 17 6 16 6 14.76V11H4V14.76C4 17.1 5.9 19 8.24 19H11V22H13V19H15.76C18.1 19 20 17.1 20 14.76V11H18Z", fill: "currentColor" })
  );
}

function miscMCP(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.2083 2.89482C12.5746 1.66158 14.6841 1.70328 16.0008 3.01865L16.1239 3.14783C16.8392 3.9385 17.1256 4.9777 16.9845 5.9683C18.0315 5.81917 19.1333 6.1472 19.939 6.95182L19.9809 6.9928C21.2975 8.30807 21.3382 10.4146 20.104 11.7794L19.98 11.9095L12.8581 19.0239C12.7679 19.1143 12.7679 19.2613 12.8581 19.3517L14.3207 20.8128L14.368 20.8662C14.5908 21.1393 14.5753 21.5417 14.3207 21.7963C14.0658 22.0506 13.6621 22.067 13.3888 21.8444L13.3361 21.7963L11.8736 20.3353C11.2397 19.7018 11.2398 18.6748 11.8736 18.0413L18.9955 10.926L19.139 10.7674C19.7636 10.0026 19.7637 8.89875 19.139 8.13399L18.9964 7.97542L18.9553 7.93444L18.7966 7.7919C18.031 7.16816 16.926 7.16814 16.1605 7.7919L16.0008 7.93444L10.0535 13.8765C9.7816 14.1475 9.3406 14.1479 9.06892 13.8765C8.7973 13.6051 8.7976 13.1646 9.06892 12.893L15.0163 6.95182L15.1599 6.79324C15.7842 6.02848 15.7843 4.92454 15.1599 4.15985L15.0163 4.00128C14.2518 3.23786 13.0425 3.19061 12.2223 3.85874L12.0636 4.00128L4.18815 11.8685C3.91628 12.1396 3.47531 12.1399 3.20361 11.8685C2.93204 11.5971 2.93222 11.1565 3.20361 10.885L11.079 3.01865L11.2083 2.89482Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.1007 4.93668C13.374 4.71424 13.777 4.73051 14.0317 4.98479C14.3035 5.25635 14.3035 5.69679 14.0317 5.9683L8.20745 11.7865C7.39226 12.6011 7.39201 13.9224 8.20745 14.7371L8.36619 14.8796C9.18629 15.5479 10.3965 15.5005 11.1611 14.7371L16.9854 8.91795C17.2572 8.64664 17.6981 8.6466 17.9699 8.91795C18.2415 9.18945 18.2415 9.62994 17.9699 9.90146L12.1456 15.7197C10.8289 17.0348 8.7193 17.0764 7.35312 15.8435L7.22381 15.7197C5.86472 14.3619 5.86472 12.1607 7.22381 10.803L13.0481 4.98479L13.1007 4.93668Z", fill: "currentColor" })
  );
}

function miscList(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.5 13.5C5.32843 13.5 6 12.8284 6 12C6 11.1716 5.32843 10.5 4.5 10.5C3.67157 10.5 3 11.1716 3 12C3 12.8284 3.67157 13.5 4.5 13.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.5 19C5.32843 19 6 18.3284 6 17.5C6 16.6716 5.32843 16 4.5 16C3.67157 16 3 16.6716 3 17.5C3 18.3284 3.67157 19 4.5 19Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 5.5H8V7.5H21V5.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 11H8V13H21V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 16.5H8V18.5H21V16.5Z", fill: "currentColor" })
  );
}

function miscLearnFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 13.74V17.54V17.61L12 21.65L19 17.61V13.74L12 17.78L5 13.74Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 3.35001L1 9.70001L12 16.05L19.92 11.47L21 10.85V19H23V9.70001L12 3.35001Z", fill: "currentColor" })
  );
}

function miscLearn(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 3.35001L1 9.70001L12 16.05L17 13.16V16.46L12 19.35L7 16.46V15.47L5 14.32V17.54V17.61L12 21.65L19 17.61V12L21 10.85V19H23V9.70001L12 3.35001ZM12 13.74L5 9.70001L12 5.66001L19 9.70001L12 13.74Z", fill: "currentColor" })
  );
}

function miscIdea(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 4C15.866 4 19 7.13401 19 11C19 13.3783 17.8131 15.4777 16 16.7422V22H8V20H14V15.583C15.7657 14.8114 17 13.0502 17 11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11C7 13.0502 8.23428 14.8114 10 15.583V18H8V16.7422C6.18693 15.4777 5 13.3783 5 11C5 7.13401 8.13401 4 12 4Z", fill: "88827E" }),
    React.createElement("path", { d: "M4 12H2V10H4V12Z", fill: "88827E" }),
    React.createElement("path", { d: "M22 12H20V10H22V12Z", fill: "88827E" }),
    React.createElement("path", { d: "M19.8281 4.41406L18.4141 5.82812L17 4.41406L18.4141 3L19.8281 4.41406Z", fill: "88827E" }),
    React.createElement("path", { d: "M6.82324 4.40918L5.40918 5.82324L3.99414 4.40918L5.40918 2.99414L6.82324 4.40918Z", fill: "88827E" }),
    React.createElement("path", { d: "M13 3H11V1H13V3Z", fill: "currentColor" })
  );
}

function miscHeadsetFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 19.33L5.51 20.15L10.25 17.42L7.9 12H4.52C4.52 11.77 4.52 11.53 4.52 11.28C4.5516 9.32436 5.35617 7.46072 6.75782 6.09655C8.15947 4.73237 10.0442 3.97859 12 3.99999C13.9592 3.97326 15.8491 4.72466 17.2551 6.08941C18.6611 7.45415 19.4684 9.32085 19.5 11.28C19.5 11.52 19.5 11.76 19.5 12H16.11L13.72 17.42L16.72 19.13L15.46 21H11V23H16.54L19.4 18.61C20.7589 16.4055 21.4854 13.8697 21.5 11.28C21.4684 8.79043 20.4503 6.41503 18.6692 4.67522C16.8882 2.93542 14.4897 1.9733 12 1.99999C9.51035 1.9733 7.1118 2.93542 5.33075 4.67522C3.5497 6.41503 2.53164 8.79043 2.5 11.28C2.52316 14.1509 3.3928 16.9511 5 19.33Z", fill: "currentColor" })
  );
}

function miscHeadset(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.52002 12C2.66094 14.3405 3.37525 16.6105 4.60002 18.61C4.74002 18.85 5.04002 19.33 5.04002 19.33L5.55002 20.15L10.29 17.42L7.90002 12H2.52002ZM6.24002 17.45C5.60658 16.3726 5.12853 15.2111 4.82002 14H6.60002L7.74002 16.58L6.24002 17.45ZM12 1.99999C9.73383 1.98308 7.53719 2.78198 5.81134 4.25078C4.0855 5.71959 2.94565 7.76025 2.60002 9.99999H4.60002C4.93857 8.29309 5.86396 6.75854 7.21564 5.66259C8.56731 4.56663 10.26 3.97842 12 3.99999C13.9593 3.97326 15.8491 4.72466 17.2551 6.08941C18.6611 7.45415 19.4684 9.32085 19.5 11.28C19.5 11.52 19.5 11.76 19.5 12H16.13L13.74 17.42L16.74 19.13L15.46 21H11V23H16.54L19.4 18.61C20.759 16.4055 21.4855 13.8697 21.5 11.28C21.4684 8.79043 20.4503 6.41503 18.6693 4.67522C16.8882 2.93542 14.4897 1.9733 12 1.99999ZM17.76 17.45L16.28 16.58L17.42 14H19.18C18.8689 15.2103 18.391 16.3714 17.76 17.45Z", fill: "currentColor" })
  );
}

function miscHandFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 14.84H3.02C3.13 16.62 3.79 18.34 4.91 19.73C6.57 21.81 9.04 23 11.7 23H15C18.31 23 21 20.31 21 17V7H19V11.81L17 11.46V3H15V11.1L13 10.75V1H11V10.4L9 10.05V2H7V13.51L5 13.16V10H3V14.84Z", fill: "currentColor" })
  );
}

function miscHand(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 14.3C3 16.27 3.68 18.2 4.91 19.74C6.57 21.81 9.04 23 11.7 23H15C18.31 23 21 20.31 21 17V7H19V11.81L17 11.46V3H15V11.1L13 10.75V1H11V10.4L9 10.05V2H7V15H9V12.08L19 13.84V17C19 19.21 17.21 21 15 21H11.7C9.65 21 7.75 20.08 6.47 18.48C5.52 17.3 5 15.81 5 14.3V11H3V14.3Z", fill: "currentColor" })
  );
}

function miscGraphBoxFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H21V3H3V21ZM15 10H17V17H15V10ZM11 7H13V17H11V7ZM7 13H9V17H7V13Z", fill: "currentColor" })
  );
}

function miscGraphBox(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 7H11V17H13V7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 10H15V17H17V10Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9 13H7V17H9V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3 3V21H21V3H3ZM19 19H5V5H19V19Z", fill: "currentColor" })
  );
}

function miscGraph(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.5 4H10.5V20H13.5V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.5 12H4.5V20H7.5V12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.5 9H16.5V20H19.5V9Z", fill: "currentColor" })
  );
}

function miscFireFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.4899 2.32L11.8999 1.34C9.9299 2.52 3.3999 7.03 3.3999 14C3.3999 18.69 7.2099 22.5 11.8999 22.5C16.5899 22.5 20.3999 18.69 20.3999 14C20.3999 10.63 18.9299 8.42 17.7499 6.44C16.4299 8.6 15.8899 10 13.8999 10C11.1699 10 10.5099 7.25 11.2999 5.51C11.8699 4.25 12.3899 3.66 13.4899 2.32Z", fill: "currentColor" })
  );
}

function miscFire(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.5 14C3.5 18.69 7.31 22.5 12 22.5C16.69 22.5 20.5 18.69 20.5 14C20.5 10.63 19.03 8.41999 17.85 6.43999C16.85 8.07999 16.08 9.99999 14 9.99999C12.51 9.99999 11.07 8.84999 11.02 7.07999C9.99 8.05999 9.64 8.66999 9.43 8.97999C10.37 11.16 12.39 12 14 12C15.44 12 16.73 11.41 17.71 10.31C18.23 11.53 18.5 12.77 18.5 14C18.5 17.58 15.58 20.5 12 20.5C8.42 20.5 5.5 17.58 5.5 14C5.5 11.86 6.36 7.08999 13.65 2.59999L12.08 1.28999C10.08 2.48999 3.5 6.98999 3.5 14Z", fill: "currentColor" })
  );
}

function miscFingerprint(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 16H11V21H13V16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.0001 16C21.0001 14.23 20.4901 12.52 19.5201 11.05L17.8501 12.15C18.6001 13.3 19.0001 14.63 19.0001 16V21H21.0001V16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.06 7.97C14.79 7.33 13.43 7 12 7C7.04 7 3 11.04 3 16V21H9V16C9 15.16 9.36 14.35 9.98 13.78C10.61 13.21 11.43 12.93 12.3 13.02C13.82 13.16 15 14.55 15 16.18V21H17V16.17C17 13.52 15.02 11.26 12.49 11.02C11.09 10.89 9.68 11.35 8.64 12.3C7.6 13.25 7 14.59 7 16V19H5V16C5 12.14 8.14 9 12 9C13.11 9 14.17 9.25 15.16 9.75C18.57 11.47 21.19 6.44 17.97 4.59C16.16 3.55 14.1 3 12 3C8.69 3 5.61 4.32 3.32 6.72L4.77 8.1C6.67 6.1 9.24 5 12 5C13.75 5 15.47 5.46 16.97 6.32C17.96 6.89 17.19 8.54 16.06 7.97Z", fill: "currentColor" })
  );
}

function miscEyeFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9998 19.91C17.1298 19.91 21.2998 16.37 23.4098 11.91C21.3198 7.47 17.1598 3.91 11.9998 3.91C6.86984 3.91 2.69984 7.45 0.589844 11.91C2.68984 16.35 6.83984 19.91 11.9998 19.91ZM11.9998 7.5C14.4798 7.5 16.4998 9.52 16.4998 12C16.4998 14.48 14.4798 16.5 11.9998 16.5C9.51984 16.5 7.49984 14.48 7.49984 12C7.49984 9.52 9.51984 7.5 11.9998 7.5Z", fill: "currentColor" })
  );
}

function miscEyeClosed(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_20333_77650)" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.43162 17.6074L3.0685 19.9706L4.48271 21.3848L7.14479 18.7227C8.61005 19.5093 10.3595 20.0449 12.41 20.0449C17.54 20.0449 21.71 16.5049 23.82 12.0449C22.7932 9.874 21.2763 7.91345 19.3909 6.47656L21.4533 4.41421L20.0391 3L17.6686 5.37046C16.089 4.53197 14.3186 4.04492 12.41 4.04492C7.28 4.04492 3.11 7.58492 1 12.0449C1.01146 12.0695 1.02394 12.0966 1.03759 12.1263C1.19072 12.4592 1.49306 13.1166 2.2 14.1449C2.20234 14.1395 2.20666 14.1288 2.21297 14.1132C2.44899 13.5295 5.47536 6.04492 12.41 6.04492C13.8237 6.04492 15.0758 6.36886 16.1678 6.87122L14.7476 8.29149C14.0658 7.8751 13.2653 7.63492 12.4102 7.63492C9.93016 7.63492 7.91016 9.65492 7.91016 12.1349C7.91016 12.9901 8.15033 13.7905 8.56673 14.4723L6.87742 16.1616C5.90888 15.4486 5.12372 14.6295 4.52 13.8849C4.09 14.7449 3.8 15.5149 3.64 15.9549C4.15356 16.5134 4.74981 17.0805 5.43162 17.6074ZM8.65143 17.2161C9.74354 17.7199 10.9959 18.0449 12.41 18.0449C17.74 18.0449 20.76 13.4849 21.58 12.0449C21.1021 11.2216 19.8951 9.35754 17.9435 7.92398L16.1825 9.68495C16.6425 10.3905 16.9102 11.2322 16.9102 12.1349C16.9102 14.6149 14.8902 16.6349 12.4102 16.6349C11.5075 16.6349 10.6658 16.3673 9.96019 15.9073L8.65143 17.2161ZM11.4316 14.4359C11.7322 14.564 12.0629 14.6349 12.4102 14.6349C13.7902 14.6349 14.9102 13.5149 14.9102 12.1349C14.9102 11.7877 14.8393 11.4569 14.7111 11.1563L11.4316 14.4359ZM13.2569 9.78214C12.9924 9.68686 12.7073 9.63492 12.4102 9.63492C11.0302 9.63492 9.91016 10.7549 9.91016 12.1349C9.91016 12.4321 9.96209 12.7172 10.0574 12.9817L13.2569 9.78214Z", fill: "currentColor" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_20333_77650" },
        React.createElement("rect", { width: 24, height: 24, fill: "white" })
      )
    )
  );
}

function miscEye(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9998 4C6.86984 4 2.69984 7.54 0.589844 12C0.729844 12.3 1.01984 12.98 1.78984 14.1C1.87984 13.89 4.87984 6 11.9998 6C17.3098 6 20.3398 10.57 21.1698 12C20.3498 13.44 17.3298 18 11.9998 18C8.22984 18 5.60984 15.69 4.10984 13.84C3.67984 14.7 3.38984 15.47 3.22984 15.91C5.05984 17.9 7.93984 20 11.9998 20C17.1298 20 21.2998 16.46 23.4098 12C21.3098 7.56 17.1598 4 11.9998 4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16.5 12.09C16.5 9.61 14.48 7.59 12 7.59C9.52 7.59 7.5 9.61 7.5 12.09C7.5 14.57 9.52 16.59 12 16.59C14.48 16.59 16.5 14.57 16.5 12.09ZM9.5 12.09C9.5 10.71 10.62 9.59 12 9.59C13.38 9.59 14.5 10.71 14.5 12.09C14.5 13.47 13.38 14.59 12 14.59C10.62 14.59 9.5 13.47 9.5 12.09Z", fill: "currentColor" })
  );
}

function miscEvergreenAI(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 10.9996H6.38481C8.93382 10.9996 11.0002 8.93323 11.0002 6.38423V1.99976H13.0002V6.38423C13.0002 8.93324 15.0666 10.9996 17.6156 10.9996H22.0003V12.9996H17.6156C15.0666 12.9996 13.0002 15.066 13.0002 17.615V22.0001H11.0002V17.615C11.0002 15.066 8.93382 12.9996 6.38481 12.9996H2V10.9996Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4 18.5859L7.53553 15.0504L8.94975 16.4646L5.41421 20.0002L4 18.5859Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.5857 4.00001L15.0502 7.53555L16.4644 8.94976L19.9999 5.41423L18.5857 4.00001Z", fill: "currentColor" }),
    React.createElement("path", { d: "M5.41406 4L8.9496 7.53553L7.53538 8.94975L3.99985 5.41421L5.41406 4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 18.5859L16.4645 15.0504L15.0502 16.4646L18.5858 20.0001L20 18.5859Z", fill: "currentColor" })
  );
}

function miscErrorHandler(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2H2v6h6zM6 4H4v2h2zm3.5 0H22v9h-6v-2h4V6H9.5zM22 16h-6v6h6zm-7.5-1L9 12l5.5-3zm0 3h-2v2h2zM9 18h2v2H9zm-1.5 0h-2v2h2zM2 18h2v2H2zm2-3.5H2v2h2zM2 11h2v2H2zm5.5 0h-2v2h2z", clipRule: "evenodd" })
  );
}

function miscDollar(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.9899 4.57V2H10.9899V4.55C8.86993 4.83 7.22993 6.22 7.01993 8.03C6.81993 9.72 7.95993 11.9 11.7299 12.96C13.4799 13.45 14.6399 14.16 15.0099 14.96C15.2399 15.45 15.1199 15.91 14.9799 16.21C14.6099 17.01 13.0899 17.72 10.5999 17.41C8.66993 17.17 7.37993 16.02 6.99993 15.64V18.16C8.97993 19.41 10.6199 19.41 10.9899 19.43V22H12.9899V19.38C14.8099 19.12 16.2099 18.3 16.7899 17.05C17.2399 16.09 17.2499 15.05 16.8199 14.12C16.1899 12.74 14.6499 11.7 12.2699 11.03C10.1299 10.43 8.87993 9.36 9.00993 8.25C9.09993 7.44 10.0399 6.55 11.5799 6.48C14.4499 6.37 16.4299 8.21 16.4999 8.28V5.82C15.6499 5.31 14.4499 4.76 12.9899 4.57Z", fill: "currentColor" })
  );
}

function miscCreditCardFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 4H2V8H22V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 20H22V11H2V20ZM11 14H13V16H11V14ZM4 14H9V16H4V14Z", fill: "currentColor" })
  );
}

function miscCreditCard(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 4V16H4V11H20V18H2V20H22V4H2ZM20 8H4V6H20V8Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11 14H6V16H11V14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 14H13V16H15V14Z", fill: "currentColor" })
  );
}

function miscCopilot(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.00039 10.9996H6.38501C8.93401 10.9996 11.0004 8.93323 11.0004 6.38422V5.99961H13.0004V6.38422C13.0004 8.93323 15.0668 10.9996 17.6158 10.9996H18.0004V12.9996H17.6158C15.0668 12.9996 13.0004 15.066 13.0004 17.615V17.9996H11.0004V17.615C11.0004 15.066 8.93401 12.9996 6.38501 12.9996H6.00039V10.9996Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.05442 11.0219H2.04297C2.49356 6.27654 6.2603 2.4976 11.0001 2.02812V4.04058C7.36599 4.49266 4.48836 7.38216 4.05442 11.0219Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2.05149 13.0219H4.06512C4.5337 16.6212 7.39464 19.4689 11.0002 19.9174V21.9298C6.28894 21.4632 2.53905 17.7269 2.05149 13.0219Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.0002 21.9294C17.7092 21.4607 21.4566 17.7253 21.944 13.0219H19.9304C19.462 16.6195 16.6035 19.4663 13.0002 19.9168V21.9294Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.9525 11.0219C21.5021 6.2781 17.7377 2.50009 13.0001 2.02859V4.04117C16.632 4.49514 19.5073 7.38373 19.9411 11.0219H21.9525Z", fill: "currentColor" })
  );
}

function miscCookieFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 11H18V6H13V2H12C9.28002 2 6.73002 3.08 4.83002 5.03C2.93002 6.98 1.93002 9.56 2.00002 12.28C2.14002 17.49 6.50002 21.85 11.71 21.99C11.81 21.99 11.9 21.99 12 21.99C14.62 21.99 17.09 20.99 18.97 19.16C20.92 17.27 22 14.72 22 12V11ZM7.00002 14.5C6.31002 14.5 5.75002 13.94 5.75002 13.25C5.75002 12.56 6.31002 12 7.00002 12C7.69002 12 8.25002 12.56 8.25002 13.25C8.25002 13.94 7.69002 14.5 7.00002 14.5ZM8.50002 9.75C7.81002 9.75 7.25002 9.19 7.25002 8.5C7.25002 7.81 7.81002 7.25 8.50002 7.25C9.19002 7.25 9.75002 7.81 9.75002 8.5C9.75002 9.19 9.19002 9.75 8.50002 9.75ZM10.75 18.25C10.06 18.25 9.50002 17.69 9.50002 17C9.50002 16.31 10.06 15.75 10.75 15.75C11.44 15.75 12 16.31 12 17C12 17.69 11.44 18.25 10.75 18.25ZM12 13.25C11.31 13.25 10.75 12.69 10.75 12C10.75 11.31 11.31 10.75 12 10.75C12.69 10.75 13.25 11.31 13.25 12C13.25 12.69 12.69 13.25 12 13.25ZM15.5 16.75C14.81 16.75 14.25 16.19 14.25 15.5C14.25 14.81 14.81 14.25 15.5 14.25C16.19 14.25 16.75 14.81 16.75 15.5C16.75 16.19 16.19 16.75 15.5 16.75Z", fill: "currentColor" })
  );
}

function miscCookie(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 11.01V6.00999H13V2.00999C12.47 2.00999 8.23002 1.54999 4.83002 5.03999C2.93002 6.98999 1.93002 9.56999 2.00002 12.29C2.14002 17.5 6.50002 21.86 11.71 22C12.72 22.03 16.07 21.99 18.96 19.17C20.17 17.99 21.04 16.56 21.53 15H19.38C18.97 16.01 18.37 16.95 17.57 17.74C16.01 19.26 13.94 20.05 11.77 20C7.60002 19.89 4.12002 16.41 4.00002 12.24C3.94002 10.06 4.74002 7.99999 6.26002 6.42999C7.55002 5.10999 9.20002 4.28999 11 4.06999V6.50999C11 7.33999 11.67 8.00999 12.5 8.00999H16V11.51C16 12.34 16.67 13.01 17.5 13.01H21.95L22 11.01H18Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 13.26C12.6904 13.26 13.25 12.7004 13.25 12.01C13.25 11.3196 12.6904 10.76 12 10.76C11.3096 10.76 10.75 11.3196 10.75 12.01C10.75 12.7004 11.3096 13.26 12 13.26Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7 14.51C7.69036 14.51 8.25 13.9504 8.25 13.26C8.25 12.5696 7.69036 12.01 7 12.01C6.30964 12.01 5.75 12.5696 5.75 13.26C5.75 13.9504 6.30964 14.51 7 14.51Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.75 18.26C11.4404 18.26 12 17.7004 12 17.01C12 16.3196 11.4404 15.76 10.75 15.76C10.0596 15.76 9.5 16.3196 9.5 17.01C9.5 17.7004 10.0596 18.26 10.75 18.26Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 16.76C16.1904 16.76 16.75 16.2004 16.75 15.51C16.75 14.8196 16.1904 14.26 15.5 14.26C14.8096 14.26 14.25 14.8196 14.25 15.51C14.25 16.2004 14.8096 16.76 15.5 16.76Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.5 9.75999C9.19036 9.75999 9.75 9.20035 9.75 8.50999C9.75 7.81964 9.19036 7.25999 8.5 7.25999C7.80964 7.25999 7.25 7.81964 7.25 8.50999C7.25 9.20035 7.80964 9.75999 8.5 9.75999Z", fill: "currentColor" })
  );
}

function miscColorFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 12C22 9.27999 20.92 6.72999 18.97 4.82999C17.02 2.92999 14.44 1.91999 11.72 1.99999C6.51002 2.14999 2.15002 6.50999 2.00002 11.72C1.92002 14.45 2.93002 17.02 4.83002 18.98C6.73002 20.92 9.28002 22 12 22H13V18C13 16.9 13.9 16 15 16H22V12ZM8.78002 15.29C8.34002 15.99 7.42002 16.21 6.72002 15.78C6.02002 15.34 5.80002 14.42 6.23002 13.72C6.67002 13.02 7.59002 12.8 8.29002 13.23C8.99002 13.66 9.21002 14.58 8.78002 15.29ZM7.46002 11C6.63002 10.98 5.98002 10.28 6.00002 9.45999C6.02002 8.62999 6.72002 7.97999 7.54002 7.99999C8.37002 8.01999 9.02002 8.71999 9.00002 9.53999C8.98002 10.37 8.28002 11.02 7.46002 11ZM12.71 8.31999C11.98 8.70999 11.07 8.43999 10.68 7.70999C10.29 6.97999 10.56 6.06999 11.29 5.67999C12.02 5.28999 12.93 5.55999 13.32 6.28999C13.71 7.01999 13.44 7.92999 12.71 8.31999ZM17.53 10.29C17.09 10.99 16.17 11.21 15.47 10.78C14.77 10.34 14.55 9.41999 14.98 8.71999C15.42 8.01999 16.34 7.79999 17.04 8.22999C17.74 8.65999 17.96 9.57999 17.53 10.29Z", fill: "currentColor" })
  );
}

function miscColor(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.97 4.83C17.02 2.93 14.43 1.92 11.72 2C6.51002 2.15 2.15002 6.51 2.00002 11.72C1.92002 14.45 2.93002 17.02 4.83002 18.98C6.73002 20.93 9.28002 22 12 22H13V20H12C9.82002 20 7.79002 19.14 6.27002 17.58C4.75002 16.02 3.94002 13.95 4.00002 11.77C4.12002 7.6 7.60002 4.12 11.77 4C13.97 3.95 16.01 4.74 17.57 6.26C19.14 7.79 20 9.82 20 12V14H15C12.79 14 11 15.79 11 18H13C13 16.9 13.9 16 15 16H22V12C22 9.28 20.92 6.73 18.97 4.83Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.18452 10.8346C8.92157 10.4564 9.2125 9.55231 8.83432 8.81525C8.45614 8.0782 7.55207 7.78728 6.81502 8.16545C6.07797 8.54363 5.78704 9.4477 6.16522 10.1848C6.5434 10.9218 7.44747 11.2127 8.18452 10.8346Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.29016 13.22C7.58016 12.78 6.66016 13 6.23016 13.71C5.79016 14.42 6.01016 15.34 6.72016 15.77C7.43016 16.21 8.35016 15.99 8.78016 15.28C9.21016 14.58 8.99016 13.66 8.29016 13.22Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.4599 10.78C16.1699 11.22 17.0899 11 17.5199 10.29C17.9599 9.58 17.7399 8.66 17.0299 8.23C16.3199 7.79 15.3999 8.01 14.9699 8.72C14.5399 9.42 14.7599 10.34 15.4599 10.78Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.3198 6.29001C12.9298 5.56001 12.0198 5.29001 11.2898 5.68001C10.5598 6.07001 10.2898 6.98001 10.6798 7.71001C11.0698 8.44001 11.9798 8.71001 12.7098 8.32001C13.4398 7.93001 13.7098 7.02001 13.3198 6.29001Z", fill: "currentColor" })
  );
}

function miscCloudFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H9V9H7C6.13 9 5.31 9.19 4.57 9.53V9.54C2.41 10.49 1 12.61 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54Z", fill: "currentColor" })
  );
}

function miscCloudCheckFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H9V9H7C6.13 9 5.31 9.19 4.57 9.53V9.54C2.41 10.49 1 12.61 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54ZM11.5 17.41L8.29 14.2L9.7 12.79L11.49 14.58L15.28 10.79L16.69 12.2L11.5 17.41Z", fill: "currentColor" })
  );
}

function miscCloudCheck(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.5 17.41L16.71 12.21L15.29 10.79L11.5 14.59L9.71004 12.79L8.29004 14.21L11.5 17.41Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H7.79C8.79 5.78 10.3 5 12 5C14.96 5 17.38 7.32 17.49 10.29L17.52 11L18.19 11.21C19.87 11.73 21 13.26 21 15C21 17.21 19.21 19 17 19H7C4.79 19 3 17.21 3 15C3 12.79 4.79 11 7 11H9V9H7C3.69 9 1 11.69 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54Z", fill: "currentColor" })
  );
}

function miscCloud(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.43 9.54C18.96 5.82 15.82 3 12 3C9.12 3 6.62 4.61 5.37 7H7.79C8.79 5.78 10.3 5 12 5C14.96 5 17.38 7.32 17.49 10.29L17.52 11L18.19 11.21C19.87 11.73 21 13.26 21 15C21 17.21 19.21 19 17 19H7C4.79 19 3 17.21 3 15C3 12.79 4.79 11 7 11H9V9H7C3.69 9 1 11.69 1 15C1 18.31 3.69 21 7 21H17C20.31 21 23 18.31 23 15C23 12.61 21.59 10.49 19.43 9.54Z", fill: "currentColor" })
  );
}

function miscClockPlay(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.99998 12C3.99998 9.87827 4.84284 7.84343 6.34313 6.34314C7.84342 4.84285 9.87825 4 12 4C13.9473 4.00177 15.8271 4.71377 17.287 6.00244C18.7468 7.29112 19.6866 9.06798 19.93 11H21.93C21.6821 8.53337 20.5268 6.24673 18.6883 4.58374C16.8497 2.92075 14.459 1.99997 11.98 2C9.32782 2 6.78428 3.05359 4.90891 4.92896C3.03355 6.80432 1.97998 9.34784 1.97998 12C1.97998 14.6522 3.03355 17.1957 4.90891 19.071C6.78428 20.9464 9.32782 22 11.98 22C12.32 22 12.65 22 12.98 22V20C12.6484 20.0436 12.3144 20.0669 11.98 20.0699C10.9252 20.0674 9.88129 19.8562 8.90841 19.4486C7.93553 19.041 7.05286 18.4451 6.31119 17.6951C5.56952 16.945 4.9835 16.0558 4.58685 15.0784C4.19019 14.101 3.99075 13.0548 3.99998 12ZM11 11.54L7.86998 14.24L9.17998 15.76L13 12.46V7H11V11.54Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 13L23 17.5L16 22V13Z", fill: "currentColor" })
  );
}

function miscClockFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM11 11.54V7H13V12.46L9.18 15.76L7.87 14.25L11 11.54Z", fill: "currentColor" })
  );
}

function miscClock(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C9.34784 2 6.80432 3.05359 4.92896 4.92896C3.05359 6.80432 2 9.34784 2 12C2 14.6522 3.05359 17.1957 4.92896 19.071C6.80432 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.071 19.071C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.80432 19.071 4.92896C17.1957 3.05359 14.6522 2 12 2ZM12 20C9.87827 20 7.84343 19.1572 6.34314 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84343 6.34314 6.34314C7.84343 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34314C19.1572 7.84343 20 9.87827 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1572 14.1217 20 12 20ZM11 11.53L7.78003 14.23L9.06995 15.77L13 12.47V7H11V11.53Z", fill: "currentColor" })
  );
}

function miscCheckpoint(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 4C9.87827 4 7.84306 4.84248 6.34277 6.34277C4.84248 7.84306 4 9.87827 4 12C4 14.1217 4.84248 16.1569 6.34277 17.6572C7.84306 19.1575 9.87827 20 12 20C12.336 19.9987 12.6698 19.9755 13 19.9326V21.9482C12.6689 21.9814 12.3353 22.0002 12 22C10.6868 22 9.38611 21.7418 8.17285 21.2393C6.95964 20.7367 5.85727 19.9998 4.92871 19.0713C3.05335 17.1959 2 14.6522 2 12C2 9.34784 3.05335 6.80407 4.92871 4.92871C6.80407 3.05335 9.34784 2 12 2V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.5 15V17.5H22V19.5H19.5V22H17.5V19.5H15V17.5H17.5V15H19.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 12.4697L9.07031 15.7705L7.78027 14.2402L11 11.5303V7H13V12.4697Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.5195 9.27051C20.8443 9.21207 21.1795 9.28435 21.4512 9.47168C21.7226 9.65901 21.909 9.94631 21.9697 10.2705C22.028 10.5951 21.9558 10.9297 21.7686 11.2012C21.5812 11.4727 21.294 11.659 20.9697 11.7197C20.6451 11.7781 20.3106 11.7058 20.0391 11.5186C19.7675 11.3312 19.5803 11.044 19.5195 10.7197C19.4612 10.3951 19.5344 10.0606 19.7217 9.78906C19.9089 9.51766 20.1955 9.33138 20.5195 9.27051Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.8389 4.51172C19.0007 4.48968 19.1653 4.50021 19.3232 4.54199C19.4812 4.58381 19.63 4.65562 19.7598 4.75488C19.8896 4.85416 19.9983 4.9786 20.0801 5.12012C20.1624 5.2625 20.2159 5.41995 20.2373 5.58301C20.2587 5.74595 20.2477 5.9116 20.2051 6.07031C20.1623 6.22918 20.0887 6.37846 19.9883 6.50879C19.8879 6.63906 19.7628 6.74823 19.6201 6.83008C19.4791 6.9126 19.323 6.96622 19.1611 6.98828C18.9993 7.01031 18.8346 7.00071 18.6768 6.95898C18.5188 6.91717 18.37 6.84438 18.2402 6.74512C18.1104 6.64584 18.0017 6.5214 17.9199 6.37988C17.8376 6.2375 17.7841 6.08005 17.7627 5.91699C17.7413 5.75405 17.7523 5.5884 17.7949 5.42969C17.8377 5.27082 17.9113 5.12154 18.0117 4.99121C18.1121 4.86094 18.2372 4.75177 18.3799 4.66992C18.5209 4.5874 18.677 4.53378 18.8389 4.51172Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.9492 2.00293C15.1129 1.99673 15.2762 2.02278 15.4297 2.08008C15.5838 2.13581 15.7259 2.22124 15.8467 2.33203C15.9675 2.44284 16.065 2.5768 16.1338 2.72559C16.2026 2.87438 16.2409 3.0354 16.2471 3.19922C16.2533 3.36293 16.2272 3.5262 16.1699 3.67969C16.1142 3.83383 16.0288 3.97588 15.918 4.09668C15.8072 4.21749 15.6732 4.31497 15.5244 4.38379C15.3756 4.45261 15.2146 4.49086 15.0508 4.49707C14.8871 4.50327 14.7238 4.47722 14.5703 4.41992C14.4162 4.36419 14.2741 4.27876 14.1533 4.16797C14.0325 4.05716 13.935 3.9232 13.8662 3.77441C13.7974 3.62562 13.7591 3.4646 13.7529 3.30078C13.7467 3.13707 13.7728 2.9738 13.8301 2.82031C13.8858 2.66617 13.9712 2.52412 14.082 2.40332C14.1928 2.28251 14.3268 2.18503 14.4756 2.11621C14.6244 2.04739 14.7854 2.00914 14.9492 2.00293Z", fill: "currentColor" })
  );
}

function miscBundle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 9H22V3H2V9H19V18.9961H5V11H3V20.9961H21V9ZM4.22222 5V7H19.7778V5H4.22222Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.5 14.5814L12.5133 10.498V13.4147H14.5L11.4867 17.498V14.5814H9.5Z", fill: "currentColor" })
  );
}

function miscBoltOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C9.34784 2 6.80432 3.05359 4.92896 4.92896C3.05359 6.80432 2 9.34784 2 12C2 14.6522 3.05359 17.1957 4.92896 19.071C6.80432 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.071 19.071C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.80432 19.071 4.92896C17.1957 3.05359 14.6522 2 12 2ZM12 20C9.87827 20 7.84343 19.1572 6.34314 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84343 6.34314 6.34314C7.84343 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34314C19.1572 7.84343 20 9.87827 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1572 14.1217 20 12 20ZM13 6L7.13 13H11V18L16.87 11H13V6Z", fill: "currentColor" })
  );
}

function miscBoltFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM13 6V11H16L11 18V13H8L13 6Z", fill: "currentColor" })
  );
}

function miscBoltAltFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.99996 23.66L20.54 9.90997H15V0.159973L3.45996 13.91H8.99996V23.66Z", fill: "currentColor" })
  );
}

function miscBoltAlt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 12H7.74996L13 5.75V12H16.25L11 18.25V16H8.99996V23.75L20.54 10H15V0.25L3.45996 14H11V12Z", fill: "currentColor" })
  );
}

function miscBolt(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C14.6522 22 17.1957 20.9464 19.071 19.071C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.80432 19.071 4.92896C17.1957 3.05359 14.6522 2 12 2C9.34784 2 6.80432 3.05359 4.92896 4.92896C3.05359 6.80432 2 9.34784 2 12C2 14.6522 3.05359 17.1957 4.92896 19.071C6.80432 20.9464 9.34784 22 12 22ZM16.87 11L11 18V13H7.13L13 6V11H16.87Z", fill: "currentColor" })
  );
}

function miscAIFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.15854 7.14316L9.15093 1.99731H10.8799L13.8722 7.14316L19.0181 10.1356V11.8645L13.8722 14.8569L10.8799 20.0027H9.15093L6.15854 14.8569L1.0127 11.8645V10.1356L6.15854 7.14316Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.7973 18.1938L19.5164 15.9911L18.2355 18.1938L16.0327 19.4748L18.2355 20.7557L19.5164 22.9585L20.7973 20.7557L23.0001 19.4748L20.7973 18.1938Z", fill: "currentColor" })
  );
}

function miscAI(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.75444 8.3773L10.0154 4.48928L12.2763 8.3773L12.6381 8.73906L16.5261 11L12.6381 13.261L12.2763 13.6227L10.0154 17.5108L8.23244 14.4447L6.67756 15.7494L9.15093 20.0027H10.8799L13.8722 14.8569L19.0181 11.8645V10.1356L13.8722 7.14316L10.8799 1.99731H9.15093L6.15854 7.14316L1.0127 10.1356V11.8645L5.25557 14.3318L6.88415 12.9652L3.50466 11L7.39268 8.73906L7.75444 8.3773Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.5159 15.9912L20.7969 18.194L22.9996 19.4749L20.7969 20.7558L19.5159 22.9586L18.235 20.7558L16.0322 19.4749L18.235 18.194L19.5159 15.9912Z", fill: "currentColor" })
  );
}

function formXCircleOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.8303 7.66998L12.0003 10.5L9.17025 7.66998L7.76025 9.07998L10.5903 11.91L7.76025 14.74L9.17025 16.15L12.0003 13.33L14.8303 16.15L16.2403 14.74L13.4103 11.91L16.2403 9.07998L14.8303 7.66998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.0701 4.93C15.1601 1.02 8.83012 1.02 4.92012 4.93C1.02012 8.83 1.02012 15.17 4.92012 19.07C8.83012 22.98 15.1601 22.98 19.0701 19.07C22.9801 15.17 22.9801 8.83 19.0701 4.93ZM17.6601 17.66C14.5301 20.78 9.47012 20.79 6.34012 17.66C3.22012 14.54 3.22012 9.47 6.34012 6.35C9.47012 3.23 14.5301 3.22 17.6601 6.35C20.7801 9.46 20.7801 14.54 17.6601 17.66Z", fill: "currentColor" })
  );
}

function formXCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.0701 4.93C15.1601 1.02 8.83012 1.02 4.92012 4.93C1.02012 8.83 1.02012 15.17 4.92012 19.07C8.83012 22.98 15.1601 22.98 19.0701 19.07C22.9801 15.17 22.9801 8.83 19.0701 4.93ZM16.2401 14.74L14.8301 16.15L12.0001 13.33L9.17012 16.16L7.76012 14.75L10.5901 11.92L7.76012 9.08L9.17012 7.67L12.0001 10.5L14.8301 7.67L16.2401 9.08L13.4101 11.91L16.2401 14.74Z", fill: "currentColor" })
  );
}

function formX(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.29 6.29001L12 10.59L7.71004 6.29001L6.29004 7.71001L10.59 12L6.29004 16.29L7.71004 17.71L12 13.41L16.29 17.71L17.71 16.29L13.41 12L17.71 7.71001L16.29 6.29001Z", fill: "currentColor" })
  );
}

function formToggle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 8H15C17.2091 8 19 9.79086 19 12C19 14.2091 17.2091 16 15 16H9C6.79086 16 5 14.2091 5 12C5 9.79086 6.79086 8 9 8ZM3 12C3 8.68629 5.68629 6 9 6H15C18.3137 6 21 8.68629 21 12C21 15.3137 18.3137 18 15 18H9C5.68629 18 3 15.3137 3 12ZM18 12C18 13.6569 16.6569 15 15 15C13.3431 15 12 13.6569 12 12C12 10.3431 13.3431 9 15 9C16.6569 9 18 10.3431 18 12Z", fill: "currentColor" })
  );
}

function formTextLong(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 5H12V7H21V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 11H12V13H21V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21 17H12V19H21V17Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 9.9375L9 9.9375V7.9375H2V9.9375L4.5 9.9375V17H6.5V9.9375Z", fill: "currentColor" })
  );
}

function formTextAlignRight(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5H19V7H5V5ZM11 9H19V11H11V9ZM19 17H11V19H19V17ZM5 13H19V15H5V13Z", fill: "currentColor" })
  );
}

function formTextAlignLeft(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5H19V7H5V5ZM5 9H13.75V11H5V9ZM13.75 17H5V19H13.75V17ZM5 13H19V15H5V13Z", fill: "currentColor" })
  );
}

function formTextAlignCenter(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5H19V7H5V5ZM8 9H16V11H8V9ZM16 17H8V19H16V17ZM5 13H19V15H5V13Z", fill: "currentColor" })
  );
}

function formText(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.25 7.5L19 7.5V5H13.25H10.75H5V7.5L10.75 7.5V19H13.25V7.5Z", fill: "currentColor" })
  );
}

function formRadioUnchecked(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" })
  );
}

function formRadioDot(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z", fill: "currentColor" })
  );
}

function formRadioCheck(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z", fill: "currentColor" })
  );
}

function formDashSquareOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 3V21H21V3H3ZM19 19H5V5H19V19Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 11H7V13H17V11Z", fill: "currentColor" })
  );
}

function formDashSquare(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 3H3V21H21V3ZM17 13H7V11H17V13Z", fill: "currentColor" })
  );
}

function formDashCircleOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 11H7V13H17V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" })
  );
}

function formDashCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM17 13H7V11H17V13Z", fill: "currentColor" })
  );
}

function formDash(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 11H7V13H17V11Z", fill: "currentColor" })
  );
}

function formCheckSquareOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 3V21H21V3H3ZM19 19H5V5H19V19ZM17.71 9.71L16.29 8.29L11 13.59L8.21 10.79L6.79 12.21L11 16.41L17.71 9.71Z", fill: "currentColor" })
  );
}

function formCheckSquare(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H21V3H3V21ZM17.71 9.71L11 16.41L6.79 12.21L8.21 10.79L11 13.59L16.29 8.29L17.71 9.71Z", fill: "currentColor" })
  );
}

function formCheckCircleOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.29 8.29L11 13.59L8.21 10.79L6.79 12.21L11 16.41L17.71 9.71L16.29 8.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z", fill: "currentColor" })
  );
}

function formCheckCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C13.9778 22 15.9112 21.4135 17.5557 20.3147C19.2002 19.2159 20.4819 17.6541 21.2388 15.8268C21.9957 13.9996 22.1937 11.9889 21.8079 10.0491C21.422 8.10929 20.4696 6.32746 19.0711 4.92894C17.6725 3.53041 15.8907 2.578 13.9509 2.19215C12.0111 1.8063 10.0004 2.00433 8.17316 2.76121C6.3459 3.51809 4.78412 4.79981 3.6853 6.4443C2.58649 8.08879 2 10.0222 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM8.21 10.79L11 13.59L16.29 8.29L17.71 9.71L11 16.41L6.79 12.21L8.21 10.79Z", fill: "currentColor" })
  );
}

function formCheck(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5102 6.82001L10.2502 15.09L5.82016 10.66L4.41016 12.07L10.2502 17.91L19.9302 8.24001L18.5102 6.82001Z", fill: "currentColor" })
  );
}

function formBlank(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H21V3H3V21ZM5 5H19V19H5V5Z", fill: "currentColor" })
  );
}

function formAddSquareOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 17H13V13H17V11H13V7H11V11H7V13H11V17Z", fill: "currentColor" }),
    React.createElement("path", { d: "M3 3V21H21V3H3ZM19 19H5V5H19V19Z", fill: "currentColor" })
  );
}

function formAddSquare(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 3H3V21H21V3ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z", fill: "currentColor" })
  );
}

function formAddCircleOutlined(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 7H11V11H7V13H11V17H13V13H17V11H13V7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" })
  );
}

function formAddCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z", fill: "currentColor" })
  );
}

function formAdd(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 19V13H19V11H13V5H11V11H5V13H11V19H13Z", fill: "currentColor" })
  );
}

function fileRemoveFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2V8H20V22H4V2H14ZM8 15H16V13H8V15ZM15.5 6.50003V2.09003L19.91 6.50003H15.5Z", fill: "currentColor" })
  );
}

function fileRemove(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.41 2L20 6.59V8H14V4H6V20H18V10H20V22H4V2H15.41Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 13V15H8V13H16Z", fill: "currentColor" })
  );
}

function fileGuideFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 3.89V21.42L22 19.83V2.31L13 3.89ZM19.5 14.74L15.5 15.45V13.42L19.5 12.71V14.74ZM19.5 10.68L15.5 11.39V9.35L19.5 8.64V10.68Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 19.84L11 21.43V3.89L2 2.31V19.84Z", fill: "currentColor" })
  );
}

function fileGuide(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 4.07L2 2.31V4.34L11 5.93V19.4L4 18.17V6.72L2 6.37V19.84L12 21.6L22 19.84V2.31L12 4.07ZM20 18.16L13 19.39V5.93L20 4.7V18.16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.5 8.65002L14.5 9.35003V11.38L18.5 10.68V8.65002Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.5 12.71L14.5 13.41V15.44L18.5 14.74V12.71Z", fill: "currentColor" })
  );
}

function fileFilledFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.5 2.09998V6.49998H19.9L15.5 2.09998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14 8V2H4V22H20V8H14ZM16 18H8V16H16V18ZM16 14H8V12H16V14Z", fill: "currentColor" })
  );
}

function fileFilled(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 16H8V18H16V16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 12H8V14H16V12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20V6.59Z", fill: "currentColor" })
  );
}

function fileFileFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14 8V2H4V22H20V8H14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 2.09003V6.50003H19.91L15.5 2.09003Z", fill: "currentColor" })
  );
}

function fileFile(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 8V6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20Z", fill: "currentColor" })
  );
}

function fileAddFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14 8V2H4V22H20V8H14ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.5 2.09003V6.50003H19.91L15.5 2.09003Z", fill: "currentColor" })
  );
}

function fileAdd(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 18V15H16V13H13V10H11V13H8V15H11V18H13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20V6.59Z", fill: "currentColor" })
  );
}

function commentWaitingFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 18H10V22H12.11L15.47 18H22V2H2V18ZM16 8.75C16.69 8.75 17.25 9.31 17.25 10C17.25 10.69 16.69 11.25 16 11.25C15.31 11.25 14.75 10.69 14.75 10C14.75 9.31 15.31 8.75 16 8.75ZM12 8.75C12.69 8.75 13.25 9.31 13.25 10C13.25 10.69 12.69 11.25 12 11.25C11.31 11.25 10.75 10.69 10.75 10C10.75 9.31 11.31 8.75 12 8.75ZM8 8.75C8.69 8.75 9.25 9.31 9.25 10C9.25 10.69 8.69 11.25 8 11.25C7.31 11.25 6.75 10.69 6.75 10C6.75 9.31 7.31 8.75 8 8.75Z", fill: "currentColor" })
  );
}

function commentWaiting(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 11.25C12.6904 11.25 13.25 10.6904 13.25 10C13.25 9.30964 12.6904 8.75 12 8.75C11.3096 8.75 10.75 9.30964 10.75 10C10.75 10.6904 11.3096 11.25 12 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 11.25C16.6904 11.25 17.25 10.6904 17.25 10C17.25 9.30964 16.6904 8.75 16 8.75C15.3096 8.75 14.75 9.30964 14.75 10C14.75 10.6904 15.3096 11.25 16 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 11.25C8.69036 11.25 9.25 10.6904 9.25 10C9.25 9.30964 8.69036 8.75 8 8.75C7.30964 8.75 6.75 9.30964 6.75 10C6.75 10.6904 7.30964 11.25 8 11.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 2V18H10V16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2Z", fill: "currentColor" })
  );
}

function commentFilledFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 18H10V22H12.11L15.47 18H22V2H2V18ZM7 7H17V9H7V7ZM7 11H15V13H7V11Z", fill: "currentColor" })
  );
}

function commentFilled(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 7H7V9H17V7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 11H7V13H15V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 2V18H10V16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2Z", fill: "currentColor" })
  );
}

function commentConvoFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5 7V16.5H12.17L9.22998 20H13.03L14.71 22H17V20H23V7H18.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 15V2H1V15H7V18H8.95L11.47 15H17Z", fill: "currentColor" })
  );
}

function commentConvo(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 2H1V15H7V13H3V4H15V13H10.53L7 17.21V20H12.53L14.21 22H16.82L13.47 18H9L11.47 15H17V9H21V18H17V20H23V7H17V2Z", fill: "currentColor" })
  );
}

function commentBlankFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 22H12.11L15.47 18H22V2H2V18H10V22Z", fill: "currentColor" })
  );
}

function commentBlank(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2V18H10V16Z", fill: "currentColor" })
  );
}

function commentAddFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 22H12.11L15.47 18H22V2H2V18H10V22ZM8 11V9H11V6H13V9H16V11H13V14H11V11H8Z", fill: "currentColor" })
  );
}

function commentAdd(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 14V11H16V9H13V6H11V9H8V11H11V14H13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 2V18H10V16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2Z", fill: "currentColor" })
  );
}

function arrowZoom(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 2L14 4H18.59L14.29 8.29L15.71 9.71L20 5.41V10L22 8V2H16Z", fill: "currentColor" }),
    React.createElement("path", { d: "M2 2V8L4 10V5.41L8.29 9.71L9.71 8.29L5.41 4H10L8 2H2Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20 18.59L15.71 14.29L14.29 15.71L18.59 20H14L16 22H22V16L20 14V18.59Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.71 15.71L8.29 14.29L4 18.59V14L2 16V22H8L10 20H5.41L9.71 15.71Z", fill: "currentColor" })
  );
}

function arrowUndo(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.96951 12L7.44951 9H14.4998C16.9851 9 18.9998 11.0147 18.9998 13.5C18.9998 15.9853 16.9851 18 14.4998 18H13.9998V20H14.4998C18.0896 20 20.9998 17.0899 20.9998 13.5C20.9998 9.91015 18.0896 7 14.4998 7H7.44951L9.96951 4H7.35951L3.99951 8L7.35951 12H9.96951Z", fill: "currentColor" })
  );
}

function arrowSmallUp(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19 15.18V12.56L12 6.69995L5 12.56V15.18L12 9.29995L19 15.18Z", fill: "currentColor" })
  );
}

function arrowSmallRight(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.4398 5H8.81982L14.6998 12L8.81982 19H11.4398L17.2998 12L11.4398 5Z", fill: "currentColor" })
  );
}

function arrowSmallLeft(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.3002 12L15.1802 5H12.5602L6.7002 12L12.5602 19H15.1802L9.3002 12Z", fill: "currentColor" })
  );
}

function arrowSmallDown(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 17.2999L19 11.4399V8.81995L12 14.6999L5 8.81995V11.4399L12 17.2999Z", fill: "currentColor" })
  );
}

function arrowResizeHorizontal(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20.3101 12L16.11 7L13.5001 7L17.6901 12L13.5001 17L16.11 17L20.3101 12ZM10.5001 7L7.89008 7L3.69006 12L7.89008 17L10.5001 17L6.31006 12L10.5001 7Z", fill: "currentColor" })
  );
}

function arrowResizeDiagonalRight(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.8759 6.1239L11.3705 5.55823L9.52496 7.40377L16.0233 7.97652L16.596 14.4748L18.4416 12.6293L17.8759 6.1239ZM7.40364 9.52509L5.55811 11.3706L6.12378 17.876L12.6292 18.4417L14.4747 16.5962L7.9764 16.0234L7.40364 9.52509Z", fill: "currentColor" })
  );
}

function arrowResizeDiagonalLeft(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.12378 6.1239L5.55811 12.6293L7.40364 14.4748L7.9764 7.97652L14.4747 7.40377L12.6292 5.55823L6.12378 6.1239ZM9.52496 16.5962L11.3705 18.4417L17.8759 17.876L18.4416 11.3706L16.596 9.52509L16.0233 16.0234L9.52496 16.5962Z", fill: "currentColor" })
  );
}

function arrowRefresh(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 4H7.1L9.62 1H7L3.65 5L7 9H9.62L7.1 6H12C13.3845 6 14.7378 6.41054 15.889 7.17971C17.0401 7.94888 17.9373 9.04213 18.4672 10.3212C18.997 11.6003 19.1356 13.0078 18.8655 14.3656C18.5954 15.7235 17.9287 16.9708 16.9497 17.9497C15.9708 18.9287 14.7235 19.5954 13.3656 19.8655C12.0078 20.1356 10.6003 19.997 9.32122 19.4672C8.04213 18.9373 6.94888 18.0401 6.17971 16.889C5.41054 15.7378 5 14.3845 5 13H3C3 14.78 3.52784 16.5201 4.51677 18.0001C5.50571 19.4802 6.91131 20.6337 8.55585 21.3149C10.2004 21.9961 12.01 22.1743 13.7558 21.8271C15.5016 21.4798 17.1053 20.6226 18.364 19.364C19.6226 18.1053 20.4798 16.5016 20.8271 14.7558C21.1743 13.01 20.9961 11.2004 20.3149 9.55585C19.6337 7.91131 18.4802 6.50571 17.0001 5.51677C15.5201 4.52784 13.78 4 12 4Z", fill: "currentColor" })
  );
}

function arrowRedo(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.03 12L17.55 9H10.4997C8.01445 9 5.99973 11.0147 5.99973 13.5C5.99973 15.9853 8.01445 18 10.4997 18H10.9997V20H10.4997C6.90988 20 3.99973 17.0899 3.99973 13.5C3.99973 9.91015 6.90988 7 10.4997 7H17.55L15.03 4H17.64L21 8L17.64 12H15.03Z", fill: "currentColor" })
  );
}

function arrowOffsite(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 3H3V21H21V19H5V3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 3L10 5H17.59L9.29004 13.29L10.71 14.71L19 6.41V14L21 12V3H12Z", fill: "currentColor" })
  );
}

function arrowLineRight(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.0002 6V18H18.0002V6H16.0002ZM5.66016 6L10.6602 12L5.66016 18H8.2702L13.2702 12L8.2702 6H5.66016Z", fill: "currentColor" })
  );
}

function arrowLineLeft(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 18H8V6H6V18ZM18.34 6H15.73L10.73 12L15.73 18H18.34L13.34 12L18.34 6Z", fill: "currentColor" })
  );
}

function arrowExpand(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8 6.24264L12.2426 2L16.4853 6.24264V9.07107L13.2397 5.82545L13.2538 11H11.2456V5.82545L8 9.07107V6.24264Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 17.6569L12.2426 21.8995L16.4853 17.6569V14.8284L13.2397 18.074L13.2467 13H11.2385L11.2456 18.074L8 14.8284V17.6569Z", fill: "currentColor" })
  );
}

function arrowExit(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H5V3H3V21ZM17.27 6H14.66L18.86 11H7V13H18.86L14.66 18H17.27L22.27 12L17.27 6Z", fill: "currentColor" })
  );
}

function arrowDropdownCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7 11.4008L12 16L17 11.4008L17 9L12 13.5992L7 9L7 11.4008Z", fill: "currentColor" })
  );
}

function arrowDropdown(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 3.68994L7 7.88995V10.4999L12 6.30994L17 10.4999V7.88995L12 3.68994ZM7 13.4999V16.1099L12 20.3099L17 16.1099V13.4999L12 17.6899L7 13.4999Z", fill: "currentColor" })
  );
}

function arrowContract(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.2426 10.8995L8 6.65685V3.82843L11.2456 7.07405L11.2385 2H13.2467L13.2397 7.07405L16.4853 3.82843V6.65685L12.2426 10.8995Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.2426 13L8 17.2426V20.0711L11.2456 16.8254L11.2385 21.8995H13.2467L13.2397 16.8254L16.4853 20.0711V17.2426L12.2426 13Z", fill: "currentColor" })
  );
}

function arrowConnect(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.5002 12H16.1102L20.3002 7L16.1102 2H13.5002L16.8602 6H4.00018V8H16.8602L13.5002 12ZM10.5002 12H7.8902L3.7002 17L7.8902 22H10.5002L7.1402 18H20.0002V16H7.1402L10.5002 12Z", fill: "currentColor" })
  );
}

function arrowCodeDots(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 10.75C11.6685 10.75 11.3505 10.8817 11.1161 11.1161C10.8817 11.3505 10.75 11.6685 10.75 12C10.75 12.3315 10.8817 12.6495 11.1161 12.8839C11.3505 13.1183 11.6685 13.25 12 13.25C12.3315 13.25 12.6495 13.1183 12.8839 12.8839C13.1183 12.6495 13.25 12.3315 13.25 12C13.25 11.6685 13.1183 11.3505 12.8839 11.1161C12.6495 10.8817 12.3315 10.75 12 10.75ZM17.25 12C17.25 11.6685 17.1183 11.3505 16.8839 11.1161C16.6495 10.8817 16.3315 10.75 16 10.75C15.6685 10.75 15.3505 10.8817 15.1161 11.1161C14.8817 11.3505 14.75 11.6685 14.75 12C14.75 12.3315 14.8817 12.6495 15.1161 12.8839C15.3505 13.1183 15.6685 13.25 16 13.25C16.3315 13.25 16.6495 13.1183 16.8839 12.8839C17.1183 12.6495 17.25 12.3315 17.25 12ZM8 10.75C7.66848 10.75 7.35051 10.8817 7.11609 11.1161C6.88167 11.3505 6.75 11.6685 6.75 12C6.75 12.3315 6.88167 12.6495 7.11609 12.8839C7.35051 13.1183 7.66848 13.25 8 13.25C8.33152 13.25 8.64949 13.1183 8.88391 12.8839C9.11833 12.6495 9.25 12.3315 9.25 12C9.25 11.6685 9.11833 11.3505 8.88391 11.1161C8.64949 10.8817 8.33152 10.75 8 10.75ZM18.27 6H15.66L20.66 12L15.66 18H18.27L23.27 12L18.27 6ZM8.34003 6H5.72998L0.72998 12L5.72998 18H8.34003L3.34003 12L8.34003 6Z", fill: "currentColor" })
  );
}

function arrowCode(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.27 6H14.66L19.66 12L14.66 18H17.27L22.27 12L17.27 6ZM6.72998 6L1.72998 12L6.72998 18H9.34003L4.34003 12L9.34003 6H6.72998Z", fill: "currentColor" })
  );
}

function arrowBranch(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 5L9 3H3V9L5 11V6.41L11 12.41V21H13V11.59L6.41 5H11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 3L13 5H17.59L13.29 9.29L14.71 10.71L19 6.41V11L21 9V3H15Z", fill: "currentColor" })
  );
}

function arrowBigUp(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 7.13994L19 12.1799V9.55994L12 3.68994L5 9.55994V12.1799L11 7.13994V19.9999H13V7.13994Z", fill: "currentColor" })
  );
}

function arrowBigRight(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.86 11H4V13H16.86L11.82 19H14.44L20.3 12L14.44 5H11.82L16.86 11Z", fill: "currentColor" })
  );
}

function arrowBigLeft(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.13994 13H19.9999V11H7.13994L12.1799 5H9.55994L3.68994 12L9.55994 19H12.1799L7.13994 13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.13994 13H19.9999V11H7.13994L12.1799 5H9.55994L3.68994 12L9.55994 19H12.1799L7.13994 13Z", fill: "currentColor" })
  );
}

function arrowBigDown(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11 16.86L5 11.82V14.44L12 20.3L19 14.44V11.82L13 16.86V4H11V16.86Z", fill: "currentColor" })
  );
}

function alertTriangleFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M0.25 21H23.75L12 1.03003L0.25 21ZM12 17.75C11.31 17.75 10.75 17.19 10.75 16.5C10.75 15.81 11.31 15.25 12 15.25C12.69 15.25 13.25 15.81 13.25 16.5C13.25 17.19 12.69 17.75 12 17.75ZM13 14H11V9.00003H13V14Z", fill: "currentColor" })
  );
}

function alertTriangle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 9.00003H11V14H13V9.00003Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17.75C12.6904 17.75 13.25 17.1904 13.25 16.5C13.25 15.8097 12.6904 15.25 12 15.25C11.3096 15.25 10.75 15.8097 10.75 16.5C10.75 17.1904 11.3096 17.75 12 17.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 1.03003L2.6 17H4.92L12 4.97003L20.25 19H1.43L0.25 21H23.75L12 1.03003Z", fill: "currentColor" })
  );
}

function alertInfoFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM13 17H11V11H13V17ZM12 6.75C12.69 6.75 13.25 7.31 13.25 8C13.25 8.69 12.69 9.25 12 9.25C11.31 9.25 10.75 8.69 10.75 8C10.75 7.31 11.31 6.75 12 6.75Z", fill: "currentColor" })
  );
}

function alertInfo(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 11H11V17H13V11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 9.25C12.6904 9.25 13.25 8.69036 13.25 8C13.25 7.30964 12.6904 6.75 12 6.75C11.3096 6.75 10.75 7.30964 10.75 8C10.75 8.69036 11.3096 9.25 12 9.25Z", fill: "currentColor" })
  );
}

function alertCircleFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM11 7H13V13H11V7ZM12 14.75C12.69 14.75 13.25 15.31 13.25 16C13.25 16.69 12.69 17.25 12 17.25C11.31 17.25 10.75 16.69 10.75 16C10.75 15.31 11.31 14.75 12 14.75Z", fill: "currentColor" })
  );
}

function alertCircleColor(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12Z", fill: "#F4DB6F", style: {
      fill: "#F4DB6F"
    } }),
    React.createElement("path", { d: "M11 7H13V13H11V7ZM12 14.75C12.69 14.75 13.25 15.31 13.25 16C13.25 16.69 12.69 17.25 12 17.25C11.31 17.25 10.75 16.69 10.75 16C10.75 15.31 11.31 14.75 12 14.75Z", fill: "#2D2E2E" })
  );
}

function alertCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 7H11V13H13V7Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17.25C12.6904 17.25 13.25 16.6904 13.25 16C13.25 15.3096 12.6904 14.75 12 14.75C11.3096 14.75 10.75 15.3096 10.75 16C10.75 16.6904 11.3096 17.25 12 17.25Z", fill: "currentColor" })
  );
}

function actionZapDetailsFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.5 2.10001V6.50001H19.9L15.5 2.10001Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2V8H20V22H4V2H14ZM15.5586 13.1292L10.7502 18.8583V14.7958H8.44189L13.2502 9.06665V13.1292H15.5586Z", fill: "currentColor" })
  );
}

function actionZapDetails(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 8V6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10.7502 18.8583L15.5586 13.1292H13.2502V9.06665L8.44189 14.7958H10.7502V18.8583Z", fill: "currentColor" })
  );
}

function actionUpload(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 10.73V13.34L11 9.14V19H13V9.14L18 13.34V10.73L12 5.73L6 10.73ZM21 4V2H3V4H21Z", fill: "currentColor" })
  );
}

function actionTrashFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.16994 22H17.8399L18.8199 9.00003H5.18994L6.16994 22Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.4201 4.55002L20.0701 2.58002L14.9501 3.47002L13.9601 2.63002L9.10008 3.49002L8.44008 4.62002L3.33008 5.51002L3.67008 7.49002L20.4201 4.55002Z", fill: "currentColor" })
  );
}

function actionTrash(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.9799 20H8.01994L7.18994 9H5.18994L6.15994 22H17.8399L18.8099 9H16.8099L15.9799 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M20.4098 4.55L20.0698 2.58L14.9498 3.47L13.9498 2.63L9.08982 3.49L8.43982 4.62L3.31982 5.51L3.66982 7.49L20.4098 4.55Z", fill: "currentColor" })
  );
}

function actionSwitchAccountFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.6698 9.5C21.202 7.68854 20.2356 6.04461 18.8801 4.75506C17.5247 3.46551 15.8347 2.58205 14.0022 2.20509C12.1697 1.82813 10.2682 1.9728 8.51382 2.62265C6.75945 3.27249 5.22255 4.40144 4.0778 5.88121C2.93306 7.36097 2.22638 9.13219 2.03809 10.9936C1.84979 12.8549 2.18744 14.7318 3.01264 16.4108C3.83785 18.0899 5.11751 19.5037 6.70621 20.4918C8.2949 21.4798 10.1289 22.0023 11.9998 22C12.1698 22 12.3298 22 12.4998 22V20C12.3332 20.0099 12.1663 20.0099 11.9998 20C10.7671 19.9973 9.55171 19.7098 8.44847 19.1599C7.34524 18.6101 6.38399 17.8126 5.63977 16.83L6.29977 15H12.4998V13.45C12.3342 13.4766 12.1673 13.4933 11.9998 13.5C11.2678 13.5042 10.5507 13.2941 9.93668 12.8957C9.32269 12.4972 8.83874 11.9278 8.54448 11.2576C8.25023 10.5874 8.15855 9.84574 8.28073 9.12407C8.40292 8.40239 8.73363 7.73224 9.23209 7.19626C9.73056 6.66027 10.375 6.28188 11.0859 6.10774C11.7968 5.93359 12.5432 5.97132 13.233 6.21624C13.9227 6.46117 14.5257 6.90259 14.9676 7.4861C15.4095 8.0696 15.671 8.76968 15.7198 9.5H21.6698ZM22.2598 17.5C22.2571 18.3629 21.9125 19.1895 21.3014 19.7987C20.6903 20.4079 19.8626 20.75 18.9998 20.75H17.0698L18.5398 19H16.5398L14.4398 21.5L16.5398 24H18.5398L17.0698 22.25H18.9998C20.2595 22.25 21.4677 21.7496 22.3585 20.8588C23.2493 19.968 23.7498 18.7598 23.7498 17.5H22.2598ZM18.9998 14.25H20.9398L19.4598 16H21.4598L23.5598 13.5L21.4598 11H19.4598L20.9298 12.75H18.9998C17.74 12.75 16.5318 13.2504 15.641 14.1412C14.7502 15.032 14.2498 16.2402 14.2498 17.5H15.7498C15.7524 16.6389 16.0957 15.8137 16.7046 15.2048C17.3135 14.5959 18.1386 14.2526 18.9998 14.25Z", fill: "currentColor" })
  );
}

function actionSwitchAccount(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.26246 9.75C8.26246 10.4917 8.48239 11.2167 8.89445 11.8334C9.30651 12.4501 9.89218 12.9307 10.5774 13.2146C11.2626 13.4984 12.0166 13.5726 12.7441 13.4279C13.4715 13.2833 14.1397 12.9261 14.6641 12.4017C15.1886 11.8772 15.5457 11.209 15.6904 10.4816C15.8351 9.75415 15.7608 9.00016 15.477 8.31494C15.1932 7.62972 14.7125 7.04404 14.0958 6.63199C13.4792 6.21993 12.7541 6 12.0125 6C11.0179 6 10.0641 6.39508 9.36081 7.09834C8.65755 7.8016 8.26246 8.75544 8.26246 9.75ZM13.7625 9.75C13.7625 10.0961 13.6598 10.4345 13.4675 10.7222C13.2752 11.01 13.0019 11.2343 12.6822 11.3668C12.3624 11.4992 12.0105 11.5339 11.6711 11.4664C11.3316 11.3988 11.0198 11.2322 10.775 10.9874C10.5303 10.7427 10.3636 10.4309 10.2961 10.0914C10.2286 9.75195 10.2632 9.40007 10.3957 9.0803C10.5281 8.76053 10.7524 8.48721 11.0402 8.29492C11.328 8.10263 11.6663 8 12.0125 8C12.4766 8 12.9217 8.18437 13.2499 8.51256C13.5781 8.84074 13.7625 9.28587 13.7625 9.75ZM5.65246 16.83C4.58878 15.4445 4.01228 13.7467 4.01246 12C4.01912 10.1027 4.69991 8.26944 5.93328 6.82766C7.16665 5.38589 8.87231 4.42941 10.7457 4.12899C12.6191 3.82858 14.5383 4.20378 16.1607 5.18762C17.783 6.17146 19.0029 7.69988 19.6025 9.5H21.6825C21.2147 7.68854 20.2482 6.04461 18.8928 4.75506C17.5374 3.46551 15.8474 2.58205 14.0149 2.20509C12.1824 1.82813 10.2809 1.9728 8.52652 2.62265C6.77214 3.27249 5.23524 4.40144 4.0905 5.88121C2.94575 7.36097 2.23907 9.13219 2.05078 10.9936C1.86249 12.8549 2.20013 14.7318 3.02534 16.4108C3.85054 18.0899 5.13021 19.5037 6.7189 20.4918C8.3076 21.4798 10.1416 22.0023 12.0125 22C12.1825 22 12.3425 22 12.5125 22V20C12.3459 20.0099 12.179 20.0099 12.0125 20C10.2792 19.9942 8.59472 19.4257 7.21246 18.38L7.71246 17H12.5125V15H6.31246L5.65246 16.83ZM22.2725 17.5C22.2698 18.3629 21.9252 19.1895 21.3141 19.7987C20.703 20.4079 19.8753 20.75 19.0125 20.75H17.0825L18.5525 19H16.5525L14.4525 21.5L16.5525 24H18.5525L17.0825 22.25H19.0125C20.2722 22.25 21.4804 21.7496 22.3712 20.8588C23.262 19.968 23.7625 18.7598 23.7625 17.5H22.2725ZM19.0125 14.25H20.9525L19.4725 16H21.4725L23.5725 13.5L21.4725 11H19.4725L20.9425 12.75H19.0125C17.7527 12.75 16.5445 13.2504 15.6537 14.1412C14.7629 15.032 14.2625 16.2402 14.2625 17.5H15.7625C15.7651 16.6389 16.1084 15.8137 16.7173 15.2048C17.3262 14.5959 18.1513 14.2526 19.0125 14.25Z", fill: "currentColor" })
  );
}

function actionShareFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 10C20.2091 10 22 8.20914 22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 14C16.8 14 15.73 14.54 15 15.38L11.37 13.56L10.48 15.35L14.1 17.16C13.51 19.86 15.67 22 18 22C20.21 22 22 20.21 22 18C22 15.79 20.21 14 18 14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.52 9.36001L12.63 7.57001L9 9.38001C8.27 8.54001 7.2 8.00001 6 8.00001C3.79 8.00001 2 9.79001 2 12C2 14.21 3.79 16 6 16C8.73 16 10.4 13.48 9.91 11.16L13.52 9.36001Z", fill: "currentColor" })
  );
}

function actionShare(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 10C20.21 10 22 8.21 22 6C22 3.79 20.21 2 18 2C15.79 2 14 3.79 14 6C14 8.21 15.79 10 18 10ZM18 4C19.1 4 20 4.9 20 6C20 7.1 19.1 8 18 8C16.9 8 16 7.1 16 6C16 4.9 16.9 4 18 4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18 14C16.8 14 15.73 14.54 15 15.38L11.37 13.56L10.48 15.35L14.1 17.16C13.51 19.86 15.67 22 18 22C20.21 22 22 20.21 22 18C22 15.79 20.21 14 18 14ZM18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18C20 19.1 19.1 20 18 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13.52 9.36L12.63 7.57L9 9.38C8.27 8.54 7.2 8 6 8C3.79 8 2 9.79 2 12C2 14.21 3.79 16 6 16C8.73 16 10.4 13.48 9.91 11.16L13.52 9.36ZM6 14C4.9 14 4 13.1 4 12C4 10.9 4.9 10 6 10C7.1 10 8 10.9 8 12C8 13.1 7.1 14 6 14Z", fill: "currentColor" })
  );
}

function actionSendFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M23.6302 12L0.970215 1.27002L2.43021 9.58002L9.00021 12.67V14.88L2.86021 11.99V12L0.970215 22.73L23.6302 12Z", fill: "currentColor" })
  );
}

function actionSend(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M23.6302 12L0.970215 1.27L2.60021 10.51L9.00021 13.52V11.31L4.39021 9.14L3.61021 4.73L18.9602 12L3.61021 19.27L4.60021 13.66L2.72021 12.78L0.970215 22.73L23.6302 12Z", fill: "currentColor" })
  );
}

function actionResendFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.5 12V9.54002L1 1.27002L2.46 9.58002L9 12.67V14.88L2.86 12L1 22.73L13.09 17C13.3075 15.6838 13.9576 14.4775 14.9373 13.572C15.9171 12.6665 17.1707 12.1134 18.5 12ZM22.25 18C22.25 18.6428 22.0594 19.2712 21.7023 19.8056C21.3452 20.3401 20.8376 20.7566 20.2437 21.0026C19.6499 21.2486 18.9964 21.313 18.366 21.1876C17.7355 21.0622 17.1564 20.7526 16.7019 20.2981C16.2474 19.8436 15.9378 19.2645 15.8124 18.6341C15.687 18.0036 15.7514 17.3502 15.9974 16.7563C16.2434 16.1624 16.6599 15.6549 17.1944 15.2977C17.7289 14.9406 18.3572 14.75 19 14.75H20.93L19.46 16.5H21.46L23.49 14L21.39 11.5H19.39L20.86 13.25H19C18.0605 13.25 17.1422 13.5286 16.361 14.0505C15.5799 14.5725 14.9711 15.3143 14.6116 16.1823C14.2521 17.0502 14.158 18.0053 14.3413 18.9267C14.5246 19.8481 14.9769 20.6945 15.6412 21.3588C16.3055 22.0231 17.1519 22.4755 18.0733 22.6588C18.9947 22.842 19.9498 22.748 20.8177 22.3885C21.6857 22.0289 22.4275 21.4201 22.9495 20.639C23.4714 19.8579 23.75 18.9395 23.75 18H22.25Z", fill: "currentColor" })
  );
}

function actionResend(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.61 20.27L4.61 14.66L2.73 13.78L1 23.73L13.09 18C13.2667 16.9587 13.7151 15.9825 14.39 15.17L3.61 20.27ZM9 14.52V12.31L4.39 10.14L3.61 5.73003L18.5 12.73V10.52L1 2.27002L2.63 11.51L9 14.52ZM22.25 19C22.25 19.6428 22.0594 20.2712 21.7023 20.8056C21.3452 21.3401 20.8376 21.7566 20.2437 22.0026C19.6499 22.2486 18.9964 22.313 18.366 22.1876C17.7355 22.0622 17.1564 21.7526 16.7019 21.2981C16.2474 20.8436 15.9378 20.2645 15.8124 19.6341C15.687 19.0036 15.7514 18.3502 15.9974 17.7563C16.2434 17.1624 16.6599 16.6549 17.1944 16.2977C17.7289 15.9406 18.3572 15.75 19 15.75H20.93L19.46 17.5H21.46L23.49 15L21.39 12.5H19.39L20.86 14.25H19C18.0605 14.25 17.1422 14.5286 16.361 15.0505C15.5799 15.5725 14.9711 16.3143 14.6116 17.1823C14.2521 18.0502 14.158 19.0053 14.3413 19.9267C14.5245 20.8481 14.9769 21.6945 15.6412 22.3588C16.3055 23.0231 17.1519 23.4755 18.0733 23.6588C18.9947 23.842 19.9498 23.748 20.8177 23.3885C21.6857 23.0289 22.4275 22.4201 22.9495 21.639C23.4714 20.8579 23.75 19.9395 23.75 19H22.25Z", fill: "currentColor" })
  );
}

function actionRenameFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.09 5L2 16.09V21H6.91L18 9.90997L13.09 5ZM20.83 7.08002L15.92 2.16998L14.5 3.59003L19.41 8.5L20.83 7.08002ZM21.43 19.43C21.0228 19.7616 20.5237 19.9606 20 20C19.6 20 19.46 19.88 19.06 18.74C18.66 17.6 18.23 16.38 16.64 16.05C14.08 15.54 11.95 17.83 9.25 20.74L9 21H11.74C13.53 19.11 15.01 17.77 16.23 18C16.66 18.09 16.85 18.49 17.16 19.39C17.47 20.29 18.08 22 20 22C21.0543 21.9438 22.0602 21.5393 22.86 20.85L21.43 19.43Z", fill: "currentColor" })
  );
}

function actionRename(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.59 8.49998L6.09 19H4V16.91L15.92 4.99998L19.41 8.49998L20.83 7.07998L15.92 2.16998L2 16.09V21H6.91L18 9.90998L16.59 8.49998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M21.4298 19.43C20.7798 19.89 20.3098 20.01 19.9998 20.01C19.5998 20.01 19.4598 19.89 19.0598 18.75C18.7098 17.75 18.2298 16.38 16.6398 16.06C14.1298 15.56 12.1298 17.65 9.00977 21H11.7498C13.5398 19.11 15.0098 17.77 16.2398 18.02C16.6698 18.11 16.8498 18.51 17.1698 19.41C17.5298 20.45 18.0798 22.01 19.9998 22.01C20.9098 22.01 21.8498 21.62 22.8598 20.85L21.4298 19.43Z", fill: "currentColor" })
  );
}

function actionReadAloudFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 17L11 21H13V4H11L6 8H2V17H6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 9.89L16.57 8.57C17.1663 9.61481 17.4799 10.797 17.4799 12C17.4799 13.203 17.1663 14.3852 16.57 15.43L15 14.11C15.3158 13.4514 15.4797 12.7304 15.4797 12C15.4797 11.2696 15.3158 10.5486 15 9.89Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.48 12C19.4808 13.6732 19.0094 15.3127 18.12 16.73L19.67 18C20.838 16.2169 21.4602 14.1316 21.4602 12C21.4602 9.86839 20.838 7.78312 19.67 6L18.12 7.3C19.004 8.70862 19.4752 10.337 19.48 12Z", fill: "currentColor" })
  );
}

function actionReadAloud(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.57 7.57L15 8.89C15.3158 9.54857 15.4797 10.2696 15.4797 11C15.4797 11.7304 15.3158 12.4514 15 13.11L16.57 14.43C17.1663 13.3852 17.4799 12.203 17.4799 11C17.4799 9.79701 17.1663 8.61481 16.57 7.57ZM19.48 11C19.4808 12.6732 19.0094 14.3127 18.12 15.73L19.67 17C20.838 15.2169 21.4602 13.1316 21.4602 11C21.4602 8.86839 20.838 6.78312 19.67 5L18.12 6.3C19.004 7.70862 19.4752 9.33697 19.48 11Z", fill: "currentColor" }),
    React.createElement("path", { d: "M11 20L6 16H2V14H7L11 17V6L7 9H4V12H2V7H6L11 3H13V20H11Z", fill: "currentColor" })
  );
}

function actionPlayFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.5 12L5 3.63V20.37L19.5 12Z", fill: "currentColor" })
  );
}

function actionPlay(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.5 12L5 3.63V20.37L19.5 12ZM7 7.09L15.5 12L7 16.91V7.09Z", fill: "currentColor" })
  );
}

function actionPinFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.9201 0.809998L10.9401 7.21L5.73006 7.66L4.06006 9.33L14.6701 19.94L16.3401 18.27L16.7901 13.06L23.1901 10.08L13.9201 0.809998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.56647 15.0136L2.2915 20.2886L3.7057 21.7028L8.98067 16.4278L7.56647 15.0136Z", fill: "currentColor" })
  );
}

function actionPin(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.9201 0.809998L10.9401 7.2L5.73006 7.66L4.06006 9.33L14.6701 19.94L16.3401 18.27L16.8001 13.06L23.1901 10.08L13.9201 0.809998ZM14.9001 11.73L14.4501 16.89L7.11006 9.55L12.2701 9.1L14.5301 4.25L19.7501 9.47L14.9001 11.73Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.56647 15.0136L2.2915 20.2886L3.7057 21.7028L8.98067 16.4278L7.56647 15.0136Z", fill: "currentColor" })
  );
}

function actionPhotoFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21 21V3H3V21H21ZM15.25 6.5C16.49 6.5 17.5 7.51 17.5 8.75C17.5 9.99 16.49 11 15.25 11C14.01 11 13 9.99 13 8.75C13 7.51 14.01 6.5 15.25 6.5ZM5 12H9.98L12.5 15H19V19H5V12Z", fill: "currentColor" })
  );
}

function actionPhoto(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 3V14H9.52L12.04 17H19V19H5V16H3V21H21V3H3ZM19 15H12.97L10.45 12H5V5H19V15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.25 11C16.4926 11 17.5 9.99264 17.5 8.75C17.5 7.50736 16.4926 6.5 15.25 6.5C14.0074 6.5 13 7.50736 13 8.75C13 9.99264 14.0074 11 15.25 11Z", fill: "currentColor" })
  );
}

function actionMoveToFolderFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 4H12.47L11.21 2.5H2V20H22V4ZM14.95 16H12.34L14.86 13H6V11H14.85L12.33 8H14.94L18.3 12L14.95 16Z", fill: "currentColor" })
  );
}

function actionMoveToFolder(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 13H14.86L12.34 16H14.95L18.31 12L14.94 8H12.33L14.85 11H6V13Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12.47 4L11.21 2.5H2V16H4V4.5H10.27L11.53 6H20V18H2V20H22V4H12.47Z", fill: "currentColor" })
  );
}

function actionLockFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 1C9.24 1 7 3.24 7 6V8H4V22H20V8H17V6C17 3.24 14.76 1 12 1ZM12 17.25C10.76 17.25 9.75 16.24 9.75 15C9.75 13.76 10.76 12.75 12 12.75C13.24 12.75 14.25 13.76 14.25 15C14.25 16.24 13.24 17.25 12 17.25ZM15 8H9V6C9 4.35 10.35 3 12 3C13.65 3 15 4.35 15 6V8Z", fill: "currentColor" })
  );
}

function actionLock(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 8V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H4V18H6V10H18V20H4V22H20V8H17ZM15 8H9V6C9 4.35 10.35 3 12 3C13.65 3 15 4.35 15 6V8Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17.25C13.2426 17.25 14.25 16.2426 14.25 15C14.25 13.7574 13.2426 12.75 12 12.75C10.7574 12.75 9.75 13.7574 9.75 15C9.75 16.2426 10.7574 17.25 12 17.25Z", fill: "currentColor" })
  );
}

function actionLink(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.1198 18.12C8.94982 19.29 7.04982 19.29 5.87982 18.12C4.70982 16.95 4.70982 15.05 5.87982 13.88L9.16982 10.59L7.75982 9.17L4.46982 12.46C2.51982 14.41 2.51982 17.58 4.46982 19.53C6.41982 21.48 9.58982 21.48 11.5398 19.53L14.8298 16.24L13.4198 14.83L10.1198 18.12Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19.5399 4.46C17.5899 2.51 14.4199 2.51 12.4699 4.46L9.16992 7.76L10.5799 9.17L13.8699 5.88C15.0399 4.71 16.9399 4.71 18.1099 5.88C19.2799 7.05 19.2799 8.95 18.1099 10.12L14.8199 13.41L16.2299 14.82L19.5199 11.53C21.4799 9.59 21.4799 6.41 19.5399 4.46Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.5807 8.00488L7.99756 14.588L9.41176 16.0022L15.9949 9.41908L14.5807 8.00488Z", fill: "currentColor" })
  );
}

function actionInsert(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 4H3V6H17V4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 9H3V11H13V9Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9 14H3V16H9V14Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 14V10H15V14H11V16H15V20H17V16H21V14H17Z", fill: "currentColor" })
  );
}

function actionFormula(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.1069 4.02604H11.075C10.2336 4.02604 9.58537 4.66901 9.58537 5.46419V10.987H12.1069V13.013H9.58537V18.5358C9.58537 20.4483 7.97598 22 6.0319 22H5V19.974H6.0319C6.87332 19.974 7.52158 19.331 7.52158 18.5358V13.013H5V10.987H7.52158V5.46419C7.52158 3.55165 9.13097 2 11.075 2H12.1069V4.02604ZM15.2777 16.3413L16.6416 14.2558H19L18.7993 14.5603L16.454 18.1413L18.7824 21.6955L18.9812 22H16.6248L16.5666 21.9139L15.2777 19.9414L13.9887 21.9139L13.9306 22H11.5741L14.0994 18.1413L11.7561 14.5603L11.5553 14.2558H13.9137L15.2777 16.3413ZM9.24391 19.4952C9.3082 19.2937 9.35436 19.0846 9.37711 18.869L9.32458 19.1927C9.30276 19.2954 9.2755 19.3962 9.24391 19.4952ZM10.7336 3.86136C10.5898 3.8894 10.4538 3.9367 10.3265 3.99733C10.5021 3.9137 10.6954 3.85832 10.9006 3.83838L10.7336 3.86136ZM6.20638 20.1616L6.37335 20.1387C6.41418 20.1306 6.45381 20.1187 6.49343 20.1081C6.40081 20.133 6.30513 20.152 6.20638 20.1616Z", fill: "currentColor" })
  );
}

function actionFlagFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.05016 15L9.78016 13H16.6602L13.7502 21H15.8802L22.4302 3H11.3002L10.5702 5H5.30016L1.66016 15H9.05016Z", fill: "currentColor" })
  );
}

function actionFlag(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.66 5H5.39L1.75 15H9.14L9.87 13H15.15L15.88 11H10.6L12.78 5H19.65L13.83 21H15.96L22.51 3H11.39L10.66 5ZM7.75 13H4.6L6.78 7H9.92L7.75 13Z", fill: "currentColor" })
  );
}

function actionFilter(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.43 6L19.52 3H17.39L14.48 11H16.61L17.7 8H22V6H18.43Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.7 6H2V8H13.97L14.7 6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.39 13L6.3 16H2V18H5.57L4.48 21H6.61L9.52 13H7.39Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9.2998 18H21.9998V16H10.0298L9.2998 18Z", fill: "currentColor" })
  );
}

function actionFallback(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5 2H19V12.0122H17V4H7V8.9102L10.0002 6.00004V8.62004L6.00017 12.48L2 8.62V6L5 8.90991V2Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 14H10V22H2V14ZM4 16V20H8V16H4Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 14H22V22H14V14ZM16 16V20H20V16H16Z", fill: "currentColor" })
  );
}

function actionExploreFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.56006 6.56L2.56006 21.41L17.4101 17.41L21.4101 2.56L6.56006 6.56ZM12.0001 14.25C11.5551 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92133 12.861C9.75103 12.4499 9.70647 11.9975 9.79329 11.561C9.88011 11.1246 10.0944 10.7237 10.4091 10.409C10.7237 10.0943 11.1246 9.88005 11.5611 9.79323C11.9976 9.70641 12.45 9.75097 12.8611 9.92127C13.2722 10.0916 13.6236 10.38 13.8709 10.75C14.1181 11.12 14.2501 11.555 14.2501 12C14.2501 12.5967 14.013 13.169 13.591 13.591C13.1691 14.0129 12.5968 14.25 12.0001 14.25Z", fill: "currentColor" })
  );
}

function actionExplore(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.5898 13.59C13.9048 13.2754 14.1194 12.8745 14.2064 12.438C14.2934 12.0015 14.2491 11.5489 14.0788 11.1376C13.9086 10.7263 13.6202 10.3748 13.2502 10.1274C12.8801 9.88005 12.445 9.74802 11.9998 9.74802C11.5547 9.74802 11.1196 9.88005 10.7495 10.1274C10.3794 10.3748 10.0911 10.7263 9.92085 11.1376C9.75063 11.5489 9.70624 12.0015 9.79328 12.438C9.88033 12.8745 10.0949 13.2754 10.4098 13.59C10.8317 14.0113 11.4036 14.248 11.9998 14.248C12.5961 14.248 13.168 14.0113 13.5898 13.59ZM6.58984 6.59L3.77984 17L5.99984 16.35L8.19984 8.2L18.5898 5.41L15.7998 15.8L3.17984 19.18L2.58984 21.41L17.4398 17.41L21.4398 2.56L6.58984 6.59Z", fill: "currentColor" })
  );
}

function actionEmailFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 8.58V20H22V8.58L12 14.35L2 8.58ZM2 4V6.27L12 12L22 6.27V4H2Z", fill: "currentColor" })
  );
}

function actionEmail(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 20H22V4H2V8.58L12 14.35L20 9.73V18H4V12L2 10.89V20ZM4 7.42V6H20V7.42L12 12L4 7.42Z", fill: "currentColor" })
  );
}

function actionEditFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 16.09V21H7.91L19 9.90998L14.09 4.99998L3 16.09ZM16.92 2.16998L15.51 3.57998L20.42 8.48998L21.83 7.07998L16.92 2.16998Z", fill: "currentColor" })
  );
}

function actionEditCircleFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM15 7L17 9L15.59 10.41L13.59 8.41L15 7ZM7.5 14.5L12.53 9.47L14.53 11.47L9.5 16.5H7.5V14.5Z", fill: "currentColor" })
  );
}

function actionEditCircle(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M7.5 14.5V16.5H9.5L14.53 11.47L12.53 9.47L7.5 14.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M14.9957 7.0001L13.5815 8.4143L15.5826 10.4154L16.9968 9.00119L14.9957 7.0001Z", fill: "currentColor" })
  );
}

function actionEditAIFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21V16.09L14.09 4.99998L19 9.90998L7.91 21H3Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15.51 3.57998L16.92 2.16998L21.83 7.07998L20.42 8.48998L15.51 3.57998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.4831 14L19.7639 16.2024L21.9662 17.4831L19.7639 18.7639L18.4831 20.9662L17.2024 18.7639L15 17.4831L17.2024 16.2024L18.4831 14Z", fill: "currentColor" })
  );
}

function actionEditAI(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20.43 8.51998L16.92 4.99998L5 16.91V19H7.09L17.6 8.47998L19.02 9.89998L7.91 21H3V16.09L16.92 2.16998L21.85 7.09998L20.43 8.51998Z", fill: "currentColor" }),
    React.createElement("path", { d: "M18.4831 14L19.7639 16.2024L21.9662 17.4831L19.7639 18.7639L18.4831 20.9662L17.2024 18.7639L15 17.4831L17.2024 16.2024L18.4831 14Z", fill: "currentColor" })
  );
}

function actionEdit(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.92 5L20.43 8.52L21.85 7.1L16.92 2.17L3 16.09V21H7.91L19.02 9.9L17.6 8.48L7.09 19H5V16.91L16.92 5Z", fill: "currentColor" })
  );
}

function actionDrag(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9 7.75C9.9665 7.75 10.75 6.9665 10.75 6C10.75 5.0335 9.9665 4.25 9 4.25C8.0335 4.25 7.25 5.0335 7.25 6C7.25 6.9665 8.0335 7.75 9 7.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 7.75C15.9665 7.75 16.75 6.9665 16.75 6C16.75 5.0335 15.9665 4.25 15 4.25C14.0335 4.25 13.25 5.0335 13.25 6C13.25 6.9665 14.0335 7.75 15 7.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9 13.75C9.9665 13.75 10.75 12.9665 10.75 12C10.75 11.0335 9.9665 10.25 9 10.25C8.0335 10.25 7.25 11.0335 7.25 12C7.25 12.9665 8.0335 13.75 9 13.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 13.75C15.9665 13.75 16.75 12.9665 16.75 12C16.75 11.0335 15.9665 10.25 15 10.25C14.0335 10.25 13.25 11.0335 13.25 12C13.25 12.9665 14.0335 13.75 15 13.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M9 19.75C9.9665 19.75 10.75 18.9665 10.75 18C10.75 17.0335 9.9665 16.25 9 16.25C8.0335 16.25 7.25 17.0335 7.25 18C7.25 18.9665 8.0335 19.75 9 19.75Z", fill: "currentColor" }),
    React.createElement("path", { d: "M15 19.75C15.9665 19.75 16.75 18.9665 16.75 18C16.75 17.0335 15.9665 16.25 15 16.25C14.0335 16.25 13.25 17.0335 13.25 18C13.25 18.9665 14.0335 19.75 15 19.75Z", fill: "currentColor" })
  );
}

function actionDownload(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 13.27V10.66L13 14.86V5H11V14.86L6 10.66V13.27L12 18.27L18 13.27ZM3 20V22H21V20H3Z", fill: "currentColor" })
  );
}

function actionCopyFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18 6H2V22H18V6Z", fill: "currentColor" }),
    React.createElement("path", { d: "M6 2V4H20V18H22V2H6Z", fill: "currentColor" })
  );
}

function actionCopy(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 22H18V6H2V22ZM4 8H16V20H4V8Z", fill: "currentColor" }),
    React.createElement("path", { d: "M6 2V4H20V18H22V2H6Z", fill: "currentColor" })
  );
}

function actionCompare(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 22L11 20H4H2V18V6V4H4H11L11 2H13V22H11ZM11 6V18H4V6H11ZM14 6H15.75H16.75V4H15.75H14V6ZM19.25 4H18.25V6H19.25H20V6.75V7.75H22V6.75V5V4H21H19.25ZM22 10.25V9.25H20V10.25V13.75V14.75H22V13.75V10.25ZM22 17.25V16.25H20V17.25V18H19.25H18.25V20H19.25H21H22V19V17.25ZM15.75 18H14V20H15.75H16.75V18H15.75Z", fill: "currentColor" })
  );
}

function actionCheckConnectionFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.2798 12L21.7798 6.64001L20.2398 5.36001L14.6698 12H9.33977L3.75977 5.36001L2.22977 6.64001L6.72977 12H2.00977V21H22.0098V12H17.2798ZM17.5098 17.75C17.2625 17.75 17.0209 17.6767 16.8153 17.5393C16.6097 17.402 16.4495 17.2068 16.3549 16.9784C16.2603 16.75 16.2356 16.4986 16.2838 16.2561C16.332 16.0137 16.4511 15.7909 16.6259 15.6161C16.8007 15.4413 17.0234 15.3223 17.2659 15.274C17.5084 15.2258 17.7597 15.2505 17.9881 15.3452C18.2165 15.4398 18.4118 15.6 18.5491 15.8055C18.6865 16.0111 18.7598 16.2528 18.7598 16.5C18.7598 16.8315 18.6281 17.1495 18.3937 17.3839C18.1592 17.6183 17.8413 17.75 17.5098 17.75ZM8.57977 7.91001L9.89977 9.48001C10.5583 9.16421 11.2794 9.00027 12.0098 9.00027C12.7401 9.00027 13.4612 9.16421 14.1198 9.48001L15.4398 7.91001C14.395 7.31373 13.2128 7.00012 12.0098 7.00012C10.8068 7.00012 9.62457 7.31373 8.57977 7.91001ZM12.0098 5.00001C13.683 4.99918 15.3225 5.47058 16.7398 6.36001L18.0098 4.81001C16.2266 3.642 14.1414 3.01984 12.0098 3.01984C9.87815 3.01984 7.79289 3.642 6.00977 4.81001L7.30977 6.36001C8.71839 5.47598 10.3467 5.0048 12.0098 5.00001Z", fill: "currentColor" })
  );
}

function actionCheckConnection(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.2798 12L21.7798 6.64001L20.2398 5.36001L14.6698 12H9.33977L3.75977 5.36001L2.22977 6.64001L6.72977 12H2.00977V17H4.00977V14H20.0098V19H2.00977V21H22.0098V12H17.2798ZM18.7598 16.5C18.7598 16.2528 18.6865 16.0111 18.5491 15.8055C18.4118 15.6 18.2165 15.4398 17.9881 15.3452C17.7597 15.2505 17.5084 15.2258 17.2659 15.274C17.0234 15.3223 16.8007 15.4413 16.6259 15.6161C16.4511 15.7909 16.332 16.0137 16.2838 16.2561C16.2356 16.4986 16.2603 16.75 16.3549 16.9784C16.4495 17.2068 16.6097 17.402 16.8153 17.5393C17.0209 17.6767 17.2625 17.75 17.5098 17.75C17.8413 17.75 18.1592 17.6183 18.3937 17.3839C18.6281 17.1495 18.7598 16.8315 18.7598 16.5ZM8.57977 7.91001L9.89977 9.48001C10.5583 9.16421 11.2794 9.00027 12.0098 9.00027C12.7401 9.00027 13.4612 9.16421 14.1198 9.48001L15.4398 7.91001C14.395 7.31373 13.2128 7.00012 12.0098 7.00012C10.8068 7.00012 9.62457 7.31373 8.57977 7.91001ZM12.0098 5.00001C13.683 4.99918 15.3225 5.47058 16.7398 6.36001L18.0098 4.81001C16.2266 3.642 14.1414 3.01984 12.0098 3.01984C9.87815 3.01984 7.79289 3.642 6.00977 4.81001L7.30977 6.36001C8.71839 5.47598 10.3467 5.0048 12.0098 5.00001Z", fill: "currentColor" })
  );
}

function actionCameraFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 14.5C13.6569 14.5 15 13.1569 15 11.5C15 9.84315 13.6569 8.5 12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 13.1569 10.3431 14.5 12 14.5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17.47 4L16.21 2.5H7.79L6.53 4H2V20H22V4H17.47ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5Z", fill: "currentColor" })
  );
}

function actionCamera(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.47 4L16.21 2.5H7.79L6.53 4H2V16H4V6H7.47L8.73 4.5H15.27L16.53 6H20V18H2V20H22V4H17.47Z", fill: "currentColor" }),
    React.createElement("path", { d: "M17 11.5C17 8.74 14.76 6.5 12 6.5C9.24 6.5 7 8.74 7 11.5C7 14.26 9.24 16.5 12 16.5C14.76 16.5 17 14.26 17 11.5ZM9 11.5C9 9.85 10.35 8.5 12 8.5C13.65 8.5 15 9.85 15 11.5C15 13.15 13.65 14.5 12 14.5C10.35 14.5 9 13.15 9 11.5Z", fill: "currentColor" })
  );
}

function actionCalendarFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7 3V5H3V22H21V5H17V3H15V5H9V3H7ZM8 18.25C7.31 18.25 6.75 17.69 6.75 17C6.75 16.31 7.31 15.75 8 15.75C8.69 15.75 9.25 16.31 9.25 17C9.25 17.69 8.69 18.25 8 18.25ZM16 10.75C16.69 10.75 17.25 11.31 17.25 12C17.25 12.69 16.69 13.25 16 13.25C15.31 13.25 14.75 12.69 14.75 12C14.75 11.31 15.31 10.75 16 10.75ZM16 15.75C16.69 15.75 17.25 16.31 17.25 17C17.25 17.69 16.69 18.25 16 18.25C15.31 18.25 14.75 17.69 14.75 17C14.75 16.31 15.31 15.75 16 15.75ZM12 10.75C12.69 10.75 13.25 11.31 13.25 12C13.25 12.69 12.69 13.25 12 13.25C11.31 13.25 10.75 12.69 10.75 12C10.75 11.31 11.31 10.75 12 10.75ZM12 15.75C12.69 15.75 13.25 16.31 13.25 17C13.25 17.69 12.69 18.25 12 18.25C11.31 18.25 10.75 17.69 10.75 17C10.75 16.31 11.31 15.75 12 15.75ZM9.25 12C9.25 12.69 8.69 13.25 8 13.25C7.31 13.25 6.75 12.69 6.75 12C6.75 11.31 7.31 10.75 8 10.75C8.69 10.75 9.25 11.31 9.25 12Z", fill: "currentColor" })
  );
}

function actionCalendar(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 4V2H15V4H9V2H7V4H3V6H7V8H9V6H15V8H17V6H19V19H5V7.5H3V21H21V4H17Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 12.25C8.69036 12.25 9.25 11.6904 9.25 11C9.25 10.3096 8.69036 9.75 8 9.75C7.30964 9.75 6.75 10.3096 6.75 11C6.75 11.6904 7.30964 12.25 8 12.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 12.25C12.6904 12.25 13.25 11.6904 13.25 11C13.25 10.3096 12.6904 9.75 12 9.75C11.3096 9.75 10.75 10.3096 10.75 11C10.75 11.6904 11.3096 12.25 12 12.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 12.25C16.6904 12.25 17.25 11.6904 17.25 11C17.25 10.3096 16.6904 9.75 16 9.75C15.3096 9.75 14.75 10.3096 14.75 11C14.75 11.6904 15.3096 12.25 16 12.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 17.25C8.69036 17.25 9.25 16.6904 9.25 16C9.25 15.3096 8.69036 14.75 8 14.75C7.30964 14.75 6.75 15.3096 6.75 16C6.75 16.6904 7.30964 17.25 8 17.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 17.25C12.6904 17.25 13.25 16.6904 13.25 16C13.25 15.3096 12.6904 14.75 12 14.75C11.3096 14.75 10.75 15.3096 10.75 16C10.75 16.6904 11.3096 17.25 12 17.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M16 17.25C16.6904 17.25 17.25 16.6904 17.25 16C17.25 15.3096 16.6904 14.75 16 14.75C15.3096 14.75 14.75 15.3096 14.75 16C14.75 16.6904 15.3096 17.25 16 17.25Z", fill: "currentColor" })
  );
}

function actionBuild(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_29242_81877)" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9583 5.08983L14.2598 7.64206L14.6023 9.42087L16.3811 9.76338L18.9574 7.03947L20.3748 5.54088C20.7778 6.12414 21.0954 6.77094 21.3095 7.4632C21.514 8.12417 21.624 8.82657 21.624 9.55469C21.624 13.459 18.459 16.624 14.5547 16.624C10.6504 16.624 7.48535 13.459 7.48535 9.55469C7.48535 5.6504 10.6504 2.48535 14.5547 2.48535C15.2335 2.48535 15.89 2.58103 16.5114 2.75964C17.2136 2.96149 17.8711 3.26926 18.4652 3.66454L16.9583 5.08983ZM17.8342 11.1377L19.6153 9.25447C19.6211 9.35376 19.624 9.45385 19.624 9.55469C19.624 12.3544 17.3544 14.624 14.5547 14.624C11.755 14.624 9.48535 12.3544 9.48535 9.55469C9.48535 6.75497 11.755 4.48535 14.5547 4.48535C14.5983 4.48535 14.6418 4.4859 14.6851 4.48699L12.8855 6.18903L12.0885 6.9429L12.2959 8.02022L12.6384 9.79903L12.8945 11.1288L14.2242 11.3848L16.003 11.7273L17.0803 11.9347L17.8342 11.1377ZM1.90137 20.7971L7.48358 15.2149L8.89778 16.6291L3.31557 22.2113L1.90137 20.7971Z", fill: "currentColor" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_29242_81877" },
        React.createElement("rect", { width: 24, height: 24, fill: "white" })
      )
    )
  );
}

function actionBugFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 18H6.35C6.7664 19.1651 7.53281 20.173 8.54426 20.8856C9.55571 21.5982 10.7627 21.9807 12 21.9807C13.2373 21.9807 14.4443 21.5982 15.4557 20.8856C16.4672 20.173 17.2336 19.1651 17.65 18H20V21H22V16H18V12H22V7H20V10H18C17.9986 8.41903 17.3733 6.90249 16.26 5.78L17.26 3H15.14L14.57 4.58C13.7667 4.19924 12.8889 4.00172 12 4.00172C11.1111 4.00172 10.2333 4.19924 9.43 4.58L8.86 3H6.73L7.73 5.78C6.62034 6.90411 5.99871 8.42045 6 10H4V7H2V12H6V16H2V21H4V18ZM12 17.5C11.7528 17.5 11.5111 17.4267 11.3055 17.2893C11.1 17.152 10.9398 16.9568 10.8452 16.7284C10.7505 16.4999 10.7258 16.2486 10.774 16.0061C10.8222 15.7637 10.9413 15.5409 11.1161 15.3661C11.2909 15.1913 11.5137 15.0722 11.7561 15.024C11.9986 14.9758 12.2499 15.0005 12.4784 15.0952C12.7068 15.1898 12.902 15.35 13.0393 15.5555C13.1767 15.7611 13.25 16.0028 13.25 16.25C13.25 16.5815 13.1183 16.8995 12.8839 17.1339C12.6495 17.3683 12.3315 17.5 12 17.5ZM13 13.5H11V9H13V13.5Z", fill: "currentColor" })
  );
}

function actionBug(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13 9H11V13.5H13V9ZM12 17.5C12.2472 17.5 12.4889 17.4267 12.6945 17.2893C12.9 17.152 13.0602 16.9568 13.1548 16.7284C13.2495 16.4999 13.2742 16.2486 13.226 16.0061C13.1778 15.7637 13.0587 15.5409 12.8839 15.3661C12.7091 15.1913 12.4863 15.0722 12.2439 15.024C12.0014 14.9758 11.7501 15.0005 11.5216 15.0951C11.2932 15.1898 11.098 15.35 10.9607 15.5555C10.8233 15.7611 10.75 16.0028 10.75 16.25C10.75 16.5815 10.8817 16.8995 11.1161 17.1339C11.3505 17.3683 11.6685 17.5 12 17.5ZM22 12V7H20V10H18C17.9986 8.41903 17.3733 6.90249 16.26 5.78L17.26 3H15.14L14.57 4.58C13.7667 4.19924 12.8889 4.00172 12 4.00172C11.1111 4.00172 10.2333 4.19924 9.43 4.58L8.86 3H6.73L7.73 5.78C7.11244 6.40959 6.64126 7.16757 6.35 8H8.56C9.00541 7.24918 9.68422 6.66469 10.4929 6.33571C11.3015 6.00673 12.1955 5.95133 13.0386 6.17796C13.8817 6.40459 14.6275 6.90081 15.1621 7.5909C15.6968 8.28098 15.9911 9.12705 16 10V16C16 17.0609 15.5786 18.0783 14.8284 18.8284C14.0783 19.5786 13.0609 20 12 20C10.9391 20 9.92172 19.5786 9.17157 18.8284C8.42143 18.0783 8 17.0609 8 16V10H4V7H2V12H6V16H2V21H4V18H6.35C6.7664 19.1651 7.53281 20.173 8.54426 20.8856C9.55571 21.5982 10.7627 21.9807 12 21.9807C13.2373 21.9807 14.4443 21.5982 15.4557 20.8856C16.4672 20.173 17.2336 19.1651 17.65 18H20V21H22V16H18V12H22Z", fill: "currentColor" })
  );
}

function actionBookmarkFill(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 22.73V2H4V22.73L12 18.11L20 22.73Z", fill: "currentColor" })
  );
}

function actionBookmark(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 6V22.73L12 18.11L20 22.73V2H4V4H18V19.27L12 15.8L6 19.27V6H4Z", fill: "currentColor" })
  );
}

function actionAutoRenew(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19 11V13C19 14.3261 18.4732 15.5979 17.5355 16.5355C16.5979 17.4732 15.3261 18 14 18H7.24L9.76 15H7.15L3.79 19L7.14 23H9.75L7.24 20H14C15.8565 20 17.637 19.2625 18.9497 17.9497C20.2625 16.637 21 14.8565 21 13V11H19ZM5 11C5 9.67392 5.52678 8.40215 6.46447 7.46447C7.40215 6.52678 8.67392 6 10 6H16.76L14.24 9H16.85L20.21 5L16.85 1H14.24L16.76 4H10C8.14348 4 6.36301 4.7375 5.05025 6.05025C3.7375 7.36301 3 9.14348 3 11V13H5V11Z", fill: "currentColor" })
  );
}

function actionAttachment(props) {
  return React.createElement(
    "svg",
    Object.assign({ width: props.size, height: props.size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.01008 21C8.29008 21 9.57008 20.51 10.5501 19.54L21.1201 8.96C22.2901 7.79 22.2901 5.89 21.1201 4.72C19.9501 3.55 18.0501 3.55 16.8801 4.72L6.31008 15.29L7.72008 16.7L18.3001 6.13C18.6901 5.74 19.3201 5.74 19.7101 6.13C20.1001 6.52 20.1001 7.15 19.7101 7.54L9.13008 18.12C7.96008 19.29 6.06008 19.29 4.89008 18.12C3.72008 16.95 3.72008 15.05 4.89008 13.88L13.3801 5.4L11.9701 3.99L3.48008 12.47C1.53008 14.42 1.53008 17.59 3.48008 19.54C4.45008 20.51 5.73008 21 7.01008 21Z", fill: "currentColor" })
  );
}

const AllIcons = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
    __proto__: null,
    actionAttachment,
    actionAutoRenew,
    actionBookmark,
    actionBookmarkFill,
    actionBug,
    actionBugFill,
    actionBuild,
    actionCalendar,
    actionCalendarFill,
    actionCamera,
    actionCameraFill,
    actionCheckConnection,
    actionCheckConnectionFill,
    actionCompare,
    actionCopy,
    actionCopyFill,
    actionDownload,
    actionDrag,
    actionEdit,
    actionEditAI,
    actionEditAIFill,
    actionEditCircle,
    actionEditCircleFill,
    actionEditFill,
    actionEmail,
    actionEmailFill,
    actionExplore,
    actionExploreFill,
    actionFallback,
    actionFilter,
    actionFlag,
    actionFlagFill,
    actionFormula,
    actionInsert,
    actionLink,
    actionLock,
    actionLockFill,
    actionMoveToFolder,
    actionMoveToFolderFill,
    actionPhoto,
    actionPhotoFill,
    actionPin,
    actionPinFill,
    actionPlay,
    actionPlayFill,
    actionReadAloud,
    actionReadAloudFill,
    actionRename,
    actionRenameFill,
    actionResend,
    actionResendFill,
    actionSend,
    actionSendFill,
    actionShare,
    actionShareFill,
    actionSwitchAccount,
    actionSwitchAccountFill,
    actionTrash,
    actionTrashFill,
    actionUpload,
    actionZapDetails,
    actionZapDetailsFill,
    alertCircle,
    alertCircleColor,
    alertCircleFill,
    alertInfo,
    alertInfoFill,
    alertTriangle,
    alertTriangleFill,
    arrowBigDown,
    arrowBigLeft,
    arrowBigRight,
    arrowBigUp,
    arrowBranch,
    arrowCode,
    arrowCodeDots,
    arrowConnect,
    arrowContract,
    arrowDropdown,
    arrowDropdownCircle,
    arrowExit,
    arrowExpand,
    arrowLineLeft,
    arrowLineRight,
    arrowOffsite,
    arrowRedo,
    arrowRefresh,
    arrowResizeDiagonalLeft,
    arrowResizeDiagonalRight,
    arrowResizeHorizontal,
    arrowSmallDown,
    arrowSmallLeft,
    arrowSmallRight,
    arrowSmallUp,
    arrowUndo,
    arrowZoom,
    commentAdd,
    commentAddFill,
    commentBlank,
    commentBlankFill,
    commentConvo,
    commentConvoFill,
    commentFilled,
    commentFilledFill,
    commentWaiting,
    commentWaitingFill,
    fileAdd,
    fileAddFill,
    fileFile,
    fileFileFill,
    fileFilled,
    fileFilledFill,
    fileGuide,
    fileGuideFill,
    fileRemove,
    fileRemoveFill,
    formAdd,
    formAddCircle,
    formAddCircleOutlined,
    formAddSquare,
    formAddSquareOutlined,
    formBlank,
    formCheck,
    formCheckCircle,
    formCheckCircleOutlined,
    formCheckSquare,
    formCheckSquareOutlined,
    formDash,
    formDashCircle,
    formDashCircleOutlined,
    formDashSquare,
    formDashSquareOutlined,
    formRadioCheck,
    formRadioDot,
    formRadioUnchecked,
    formText,
    formTextAlignCenter,
    formTextAlignLeft,
    formTextAlignRight,
    formTextLong,
    formToggle,
    formX,
    formXCircle,
    formXCircleOutlined,
    miscAI,
    miscAIFill,
    miscBolt,
    miscBoltAlt,
    miscBoltAltFill,
    miscBoltFill,
    miscBoltOutlined,
    miscBundle,
    miscCheckpoint,
    miscClock,
    miscClockFill,
    miscClockPlay,
    miscCloud,
    miscCloudCheck,
    miscCloudCheckFill,
    miscCloudFill,
    miscColor,
    miscColorFill,
    miscCookie,
    miscCookieFill,
    miscCopilot,
    miscCreditCard,
    miscCreditCardFill,
    miscDollar,
    miscErrorHandler,
    miscEvergreenAI,
    miscEye,
    miscEyeClosed,
    miscEyeFill,
    miscFingerprint,
    miscFire,
    miscFireFill,
    miscGraph,
    miscGraphBox,
    miscGraphBoxFill,
    miscHand,
    miscHandFill,
    miscHeadset,
    miscHeadsetFill,
    miscIdea,
    miscLearn,
    miscLearnFill,
    miscList,
    miscMCP,
    miscMic,
    miscMicFill,
    miscPackage,
    miscPie,
    miscPieFill,
    miscPin,
    miscPinFill,
    miscSecurity,
    miscSecurityFill,
    miscSteps,
    miscSteps1,
    miscSteps2,
    miscSteps3,
    miscStepsAlt,
    miscStepsFill,
    miscTimelapse,
    miscTrigger,
    miscUptime,
    miscUptimeFill,
    miscWallet,
    miscWalletFill,
    miscWorld,
    miscWorldFill,
    navAIChatbot,
    navApps,
    navAppsFill,
    navBell,
    navBellFill,
    navBlog,
    navBlogFill,
    navBriefcase,
    navBriefcaseFill,
    navCanvas,
    navCentral,
    navCog,
    navCogFill,
    navConnectedAssets,
    navConnectedAssetsFill,
    navCustomAction,
    navDashboard,
    navDashboardFill,
    navExplore,
    navExploreFill,
    navFolder,
    navFolderFill,
    navFunctions,
    navGridView,
    navHelp,
    navHelpFill,
    navHome,
    navHomeFill,
    navIntegrations,
    navIntegrationsFill,
    navInterfaces,
    navMCP,
    navMenu,
    navMenuAlt,
    navMoreHoriz,
    navMoreVert,
    navProductHub,
    navProjects,
    navProjectsFill,
    navSearch,
    navSearchFill,
    navTable,
    navTableFill,
    navTables,
    navVersions,
    navVersionsFill,
    partnerDashboard,
    partnerEmbed,
    personAdd,
    personAddFill,
    personCircle,
    personCircleFill,
    personGroup,
    personGroupFill,
    personOne,
    personOneFill,
    personSettings,
    ratingCool,
    ratingHappy,
    ratingHappyAlt,
    ratingHeart,
    ratingHeartFill,
    ratingNeutral,
    ratingNeutralAlt,
    ratingSad,
    ratingSadAlt,
    ratingStar,
    ratingStarFill,
    ratingThumbsBoth,
    ratingThumbsBothFill,
    ratingThumbsDown,
    ratingThumbsDownFill,
    ratingThumbsUp,
    ratingThumbsUpFill,
    ratingVeryHappy,
    ratingVeryHappyAlt,
    ratingVerySad,
    ratingVerySadAlt,
    ratingWink,
    ratingWinkAlt,
    statusFilter,
    statusFilterFill,
    statusPaused,
    statusPlaying,
    statusPlayingFill,
    statusStatus,
    statusStatusFill,
    statusStop,
    statusStopFill,
    team,
    teamFill,
    zapierLogo
}, Symbol.toStringTag, { value: 'Module' }));

const icon = "zapier-zinnia-icons__icon__8f1EW1A1";
const styles = {
	icon: icon
};

const iconNames = Object.freeze(
  // Object.keys isn't smart enough to know the keys are all `IconName`, but I
  // promise they are!
  Object.keys(AllIcons)
);
function isIconName(name) {
  return iconNamesSet.has(name);
}
const iconNamesSet = new Set(iconNames);
function Icon({
  className,
  name,
  "aria-label": ariaLabel,
  // Aria hidden should probably only default to true if there's no label,
  // right? Trying to copy existing behavior...
  "aria-hidden": ariaHidden = !!ariaLabel,
  // Should this really be true by default? People shouldn't be making icons
  // directly clickable, right?
  canAcceptPointerEvents = true,
  color = "inherit",
  isBlock = false,
  shouldAnimateFill = true,
  size = "small"
}) {
  let Component = AllIcons[name];
  if (!Component) {
    console.error("No such icon", name);
    Component = FallbackIcon;
  }
  return React.createElement(Component, {
    size: getRealSize(size),
    className: [styles.icon, className].filter((x) => x).join(" "),
    "aria-hidden": ariaHidden,
    //
    // https://css-tricks.com/accessible-svgs/
    //
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-label
    //
    role: "img",
    "data-name": name,
    "aria-label": ariaLabel,
    "data-block": isBlock,
    "data-pointer-events": canAcceptPointerEvents,
    "data-animate-fill": shouldAnimateFill,
    style: { "--color": Colors[color] }
  });
}
function getRealSize(size) {
  if (!size)
    return 24;
  if (size === "small")
    return 24;
  if (size === "medium")
    return 36;
  if (size === "large")
    return 48;
  return size;
}
function FallbackIcon({ size = 24, className }) {
  return React.createElement(
    "svg",
    { "aria-label": "Could not load icon", className, "data-is-missing-icon": "true", viewBox: "0 0 24 24", width: size, height: size },
    React.createElement("rect", { height: "24", width: "24", x: "0", y: "0", fill: "currentColor" })
  );
}

export { Icon, iconNames, isIconName };
//# sourceMappingURL=zinnia-icons.mjs.map
